// *****************
// CustomEvent
// *****************
(function () {
    if ( typeof window.CustomEvent === "function" ) return false; //If not IE
  
    console.log('adding CustomEvent polyfill');
    function CustomEvent ( event, params ) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent( 'CustomEvent' );
      evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
      return evt;
     }
  
    CustomEvent.prototype = window.Event.prototype;
  
    window.CustomEvent = CustomEvent;
})();

// *********************
// URLSearchParams
// *********************
if ('URLSearchParams' in window) {
    // do nothing
}
else {
    console.log('adding URLSearchParams polyfill');
    /* from: https://github.com/ungap/url-search-params */
    /* (c) Andrea Giammarchi - ISC */
    var self = this || {};
    try {
    (function (URLSearchParams, plus) {
        if (
        new URLSearchParams('q=%2B').get('q') !== plus ||
        new URLSearchParams({q: plus}).get('q') !== plus ||
        new URLSearchParams([['q', plus]]).get('q') !== plus ||
        new URLSearchParams('q=\n').toString() !== 'q=%0A' ||
        new URLSearchParams({q: ' &'}).toString() !== 'q=+%26' ||
        new URLSearchParams({q: '%zx'}).toString() !== 'q=%25zx'
        )
        throw URLSearchParams;
        self.URLSearchParams = URLSearchParams;
    }(URLSearchParams, '+'));
    } catch(URLSearchParams) {
    (function (Object, String, isArray) {'use strict';
        var create = Object.create;
        var defineProperty = Object.defineProperty;
        var find = /[!'\(\)~]|%20|%00/g;
        var findPercentSign = /%(?![0-9a-fA-F]{2})/g;
        var plus = /\+/g;
        var replace = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
        };
        var proto = {
        append: function (key, value) {
            appendTo(this._ungap, key, value);
        },
        delete: function (key) {
            delete this._ungap[key];
        },
        get: function (key) {
            return this.has(key) ? this._ungap[key][0] : null;
        },
        getAll: function (key) {
            return this.has(key) ? this._ungap[key].slice(0) : [];
        },
        has: function (key) {
            return key in this._ungap;
        },
        set: function (key, value) {
            this._ungap[key] = [String(value)];
        },
        forEach: function (callback, thisArg) {
            var self = this;
            for (var key in self._ungap)
            self._ungap[key].forEach(invoke, key);
            function invoke(value) {
            callback.call(thisArg, value, String(key), self);
            }
        },
        toJSON: function () {
            return {};
        },
        toString: function () {
            var query = [];
            for (var key in this._ungap) {
            var encoded = encode(key);
            for (var
                i = 0,
                value = this._ungap[key];
                i < value.length; i++
            ) {
                query.push(encoded + '=' + encode(value[i]));
            }
            }
            return query.join('&');
        }
        };
        for (var key in proto)
        defineProperty(URLSearchParams.prototype, key, {
            configurable: true,
            writable: true,
            value: proto[key]
        });
        self.URLSearchParams = URLSearchParams;
        function URLSearchParams(query) {
        //var dict = create(null);
        //defineProperty(this, '_ungap', {value: dict});
        var dict = {};
        var i, length, pairs, value;
        switch (true) {
            case !query:
            break;
            case typeof query === 'string':
                if (query.charAt(0) === '?') {
                    query = query.slice(1);
                }
                pairs = query.split('&');
                length = pairs.length;
                for (i = 0; i < length; i++) {
                    var value = pairs[i];
                    var index = value.indexOf('=');
                    if (-1 < index) {
                        appendTo(
                            dict,
                            decode(value.slice(0, index)),
                            decode(value.slice(index + 1))
                        );
                    } else if (value.length){
                        appendTo(
                            dict,
                            decode(value),
                            ''
                        );
                    }
                }
                break;
            case isArray(query): 
                length = query.length;
                for (i = 0; i < length; i++) {
                    value = query[i];
                    appendTo(dict, value[0], value[1]);
                }
                break;
            case 'forEach' in query:
                query.forEach(addEach, dict);
            break;
            default:
                for (var key in query)
                    appendTo(dict, key, query[key]);
        }
        this._ungap = dict;
        }

        function addEach(value, key) {
            appendTo(this, key, value);
        }

        function appendTo(dict, key, value) {
        var res = isArray(value) ? value.join(',') : value;
        if (key in dict)
            dict[key].push(res);
        else
            dict[key] = [res];
        }

        function decode(str) {
        return decodeURIComponent(str.replace(findPercentSign, '%25').replace(plus, ' '));
        }

        function encode(str) {
        return encodeURIComponent(str).replace(find, replacer);
        }

        function replacer(match) {
        return replace[match];
        }

    }(Object, String, Array.isArray));
    }

    (function (URLSearchParamsProto) {

    var iterable = false;
    try { iterable = !!Symbol.iterator; } catch (o_O) {}

    /* istanbul ignore else */
    if (!('forEach' in URLSearchParamsProto)) {
        URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
        var self = this;
        var names = Object.create(null);
        this.toString()
            .replace(/=[\s\S]*?(?:&|$)/g, '=')
            .split('=')
            .forEach(function (name) {
                if (!name.length || name in names)
                return;
                (names[name] = self.getAll(name)).forEach(function(value) {
                callback.call(thisArg, value, name, self);
                });
            });
        };
    }

    /* istanbul ignore else */
    if (!('keys' in URLSearchParamsProto)) {
        URLSearchParamsProto.keys = function keys() {
        return iterator(this, function(value, key) { this.push(key); });
        };
    }

    /* istanbul ignore else */
    if (!('values' in URLSearchParamsProto)) {
        URLSearchParamsProto.values = function values() {
        return iterator(this, function(value, key) { this.push(value); });
        };
    }

    /* istanbul ignore else */
    if (!('entries' in URLSearchParamsProto)) {
        URLSearchParamsProto.entries = function entries() {
        return iterator(this, function(value, key) { this.push([key, value]); });
        };
    }

    /* istanbul ignore else */
    if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
        URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
    }

    /* istanbul ignore else */
    if (!('sort' in URLSearchParamsProto)) {
        URLSearchParamsProto.sort = function sort() {
        var
            entries = this.entries(),
            entry = entries.next(),
            done = entry.done,
            keys = [],
            values = Object.create(null),
            i, key, value
        ;
        while (!done) {
            value = entry.value;
            key = value[0];
            keys.push(key);
            if (!(key in values)) {
            values[key] = [];
            }
            values[key].push(value[1]);
            entry = entries.next();
            done = entry.done;
        }
        // not the champion in efficiency
        // but these two bits just do the job
        keys.sort();
        for (i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            key = keys[i];
            this.append(key, values[key].shift());
        }
        };
    }

    function iterator(self, callback) {
        var items = [];
        self.forEach(callback, items);
        /* istanbul ignore next */
        return iterable ?
        items[Symbol.iterator]() :
        {
            next: function() {
            var value = items.shift();
            return {done: value === void 0, value: value};
            }
        };
    }

    /* istanbul ignore next */
    (function (Object) {
        var
        dP = Object.defineProperty,
        gOPD = Object.getOwnPropertyDescriptor,
        createSearchParamsPollute = function (search) {
            function append(name, value) {
            URLSearchParamsProto.append.call(this, name, value);
            name = this.toString();
            search.set.call(this._usp, name ? ('?' + name) : '');
            }
            function del(name) {
            URLSearchParamsProto.delete.call(this, name);
            name = this.toString();
            search.set.call(this._usp, name ? ('?' + name) : '');
            }
            function set(name, value) {
            URLSearchParamsProto.set.call(this, name, value);
            name = this.toString();
            search.set.call(this._usp, name ? ('?' + name) : '');
            }
            return function (sp, value) {
            sp.append = append;
            sp.delete = del;
            sp.set = set;
            return dP(sp, '_usp', {
                configurable: true,
                writable: true,
                value: value
            });
            };
        },
        createSearchParamsCreate = function (polluteSearchParams) {
            return function (obj, sp) {
            dP(
                obj, '_searchParams', {
                configurable: true,
                writable: true,
                value: polluteSearchParams(sp, obj)
                }
            );
            return sp;
            };
        },
        updateSearchParams = function (sp) {
            var append = sp.append;
            sp.append = URLSearchParamsProto.append;
            URLSearchParams.call(sp, sp._usp.search.slice(1));
            sp.append = append;
        },
        verifySearchParams = function (obj, Class) {
            if (!(obj instanceof Class)) throw new TypeError(
            "'searchParams' accessed on an object that " +
            "does not implement interface " + Class.name
            );
        },
        upgradeClass = function (Class) {
            var
            ClassProto = Class.prototype,
            searchParams = gOPD(ClassProto, 'searchParams'),
            href = gOPD(ClassProto, 'href'),
            search = gOPD(ClassProto, 'search'),
            createSearchParams
            ;
            if (!searchParams && search && search.set) {
            createSearchParams = createSearchParamsCreate(
                createSearchParamsPollute(search)
            );
            Object.defineProperties(
                ClassProto,
                {
                href: {
                    get: function () {
                    return href.get.call(this);
                    },
                    set: function (value) {
                    var sp = this._searchParams;
                    href.set.call(this, value);
                    if (sp) updateSearchParams(sp);
                    }
                },
                search: {
                    get: function () {
                    return search.get.call(this);
                    },
                    set: function (value) {
                    var sp = this._searchParams;
                    search.set.call(this, value);
                    if (sp) updateSearchParams(sp);
                    }
                },
                searchParams: {
                    get: function () {
                    verifySearchParams(this, Class);
                    return this._searchParams || createSearchParams(
                        this,
                        new URLSearchParams(this.search.slice(1))
                    );
                    },
                    set: function (sp) {
                    verifySearchParams(this, Class);
                    createSearchParams(this, sp);
                    }
                }
                }
            );
            }
        }
        ;
        try {
        upgradeClass(HTMLAnchorElement);
        if (/^function|object$/.test(typeof URL) && URL.prototype)
            upgradeClass(URL);
        } catch (meh) {}
    }(Object));

    }(self.URLSearchParams.prototype, Object));
}

// ***************
// prepend
// ***************
// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
if (!("prepend" in Element.prototype)) {
    (function (arr) {
        arr.forEach(function (item) {
          if (item.hasOwnProperty('prepend')) {
            return;
          }
          Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
              var argArr = Array.prototype.slice.call(arguments),
                docFrag = document.createDocumentFragment();
      
              argArr.forEach(function (argItem) {
                var isNode = argItem instanceof Node;
                docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
              });
      
              this.insertBefore(docFrag, this.firstChild);
            }
          });
        });
      })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
}

// IE11には存在しないから
if (!String.prototype.repeat) {
    String.prototype.repeat = function(count) {
      'use strict';
      if (this == null) {
        throw new TypeError('can\'t convert ' + this + ' to object');
      }
      var str = '' + this;
      count = +count;
      if (count != count) {
        count = 0;
      }
      if (count < 0) {
        throw new RangeError('repeat count must be non-negative');
      }
      if (count == Infinity) {
        throw new RangeError('repeat count must be less than infinity');
      }
      count = Math.floor(count);
      if (str.length == 0 || count == 0) {
        return '';
      }
      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) {
        throw new RangeError('repeat count must not overflow maximum string size');
      }
      var rpt = '';
      for (;;) {
        if ((count & 1) == 1) {
          rpt += str;
        }
        count >>>= 1;
        if (count == 0) {
          break;
        }
        str += str;
      }
      return rpt;
    };
  }

  // IE11にはtemplateの機能がないから追加します
// https://github.com/neovov/template-element-polyfill
function _IETemplatesPolyfill() {
    // IEじゃないとき何もしない
    if (typeof(document.documentMode) === 'undefined') {
        return;
    }

	var support = ("content" in document.createElement("template"));

	// Set the content property if missing
	if (!support) {
		var
			/**
			 * Prefer an array to a NodeList
			 * Otherwise, updating the content property of a node
			 * will update the NodeList and we'll loose the nested <template>
			 */
			templates = Array.prototype.slice.call(document.getElementsByTagName("template")),
			template, content, fragment, node, i = 0, j;

		// For each <template> element get its content and wrap it in a document fragment
		while ((template = templates[i++])) {
			content  = template.children;
			fragment = document.createDocumentFragment();

			for (j = 0; node == content[j]; j++) {
				fragment.appendChild(node.cloneNode(true));
			}

			template.content = fragment;
		}
	}

	// Prepare a clone function to allow nested <template> elements
	function clone() {
		var
			templates = this.querySelectorAll("template"),
			fragments = [],
			template,
			i = 0;

		// If the support is OK simply clone and return
		if (support) {
			template  = this.cloneNode(true);
			templates = template.content.querySelectorAll("template");

			// Set the clone method for each nested <template> element
			for (; templates[i]; i++) {
				templates[i].clone = clone;
			}

			return template;
		}

		// Loop through nested <template> to retrieve the content property
		for (; templates[i]; i++) {
			fragments.push(templates[i].content);
		}

		// Now, clone the document fragment
		template = this.cloneNode(true);

		// Makes sure the clone have a "content" and "clone" properties
		template.content = this.content;
		template.clone   = clone;

		/**
		 * Retrieve the nested <template> once again
		 * Since we just cloned the document fragment,
		 * the content's property of the nested <template> might be undefined
		 * We have to re-set it using the fragment array we previously got
		 */
		templates = template.querySelectorAll("template");

		// Loop to set the content property of each nested template
		for (i = 0; templates[i]; i++) {
			templates[i].content = fragments[i];
			templates[i].clone   = clone; // Makes sure to set the clone method as well
		}

		return template;
	}

	var
		templates = document.querySelectorAll("template"),
		template, i = 0;

	// Pollute the DOM with a "clone" method on each <template> element
	while ((template = templates[i++])) {
		template.clone = clone;
	}
}
_IETemplatesPolyfill();

/*****
 * Object.assign polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#polyfill
 */

 if (typeof(Object.assign) !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target === null || target === undefined) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource !== null && nextSource !== undefined) {
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
                }
            }
            }
        }
        return to;
        },
        writable: true,
        configurable: true
    });
}

/*****
 * getAttributeNames polyfill
 */
 if (typeof(Element.prototype.getAttributeNames) === "undefined") {
    Element.prototype.getAttributeNames = function () {
        var attributes = this.attributes;
        var length = attributes.length;
        var result = new Array(length);
        var i;
        for (i = 0; i < length; i++) {
            result[i] = attributes[i].name;
        }
        
        return result;
    };
}


/* Polyfill service v3.110.1
 * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.
 * 
 * Features requested: URL,URL.prototype.toJSON
 * 
 * - _ESAbstract.ArrayCreate, License: CC0 (required by "URL", "Array.from")
 * - _ESAbstract.Call, License: CC0 (required by "URL", "Array.from", "_ESAbstract.ToString", "_ESAbstract.ToPrimitive", "_ESAbstract.OrdinaryToPrimitive")
 * - _ESAbstract.CreateDataProperty, License: CC0 (required by "URL", "Array.from", "Set", "_ESAbstract.CreateIterResultObject")
 * - _ESAbstract.CreateDataPropertyOrThrow, License: CC0 (required by "URL", "Array.from")
 * - _ESAbstract.CreateMethodProperty, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.Get, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.HasOwnProperty, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyDescriptor")
 * - _ESAbstract.IsCallable, License: CC0 (required by "URL", "Array.from", "_ESAbstract.ToString", "_ESAbstract.ToPrimitive", "_ESAbstract.OrdinaryToPrimitive")
 * - _ESAbstract.SameValueNonNumber, License: CC0 (required by "URL", "Array.from", "Set", "_ESAbstract.SameValueZero")
 * - _ESAbstract.ToBoolean, License: CC0 (required by "URL", "Array.from", "Set", "_ESAbstract.IteratorComplete")
 * - _ESAbstract.ToObject, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.GetV, License: CC0 (required by "URL", "Array.from", "_ESAbstract.GetIterator")
 * - _ESAbstract.GetMethod, License: CC0 (required by "URL", "Array.from", "_ESAbstract.ToString", "_ESAbstract.ToPrimitive")
 * - _ESAbstract.Type, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyDescriptor", "_ESAbstract.ToPropertyKey")
 * - _ESAbstract.CreateIterResultObject, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.GetPrototypeFromConstructor, License: CC0 (required by "URL", "Array.from", "Set", "_ESAbstract.OrdinaryCreateFromConstructor")
 * - _ESAbstract.OrdinaryCreateFromConstructor, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.IsConstructor, License: CC0 (required by "URL", "Array.from", "_ESAbstract.Construct")
 * - _ESAbstract.Construct, License: CC0 (required by "URL", "Array.from")
 * - _ESAbstract.IteratorClose, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.IteratorComplete, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.IteratorNext, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.IteratorStep, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.IteratorValue, License: CC0 (required by "URL", "Array.from", "Set")
 * - _ESAbstract.OrdinaryToPrimitive, License: CC0 (required by "URL", "Array.from", "_ESAbstract.ToString", "_ESAbstract.ToPrimitive")
 * - _ESAbstract.SameValueZero, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.ToInteger, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.ToLength, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames", "Array.prototype.includes")
 * - _ESAbstract.ToPrimitive, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyDescriptor", "_ESAbstract.ToPropertyKey")
 * - _ESAbstract.ToString, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyDescriptor", "_ESAbstract.ToPropertyKey")
 * - _ESAbstract.ToPropertyKey, License: CC0 (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyDescriptor")
 * - Array.prototype.includes, License: MIT (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames")
 * - Object.getOwnPropertyDescriptor, License: CC0 (required by "URL", "Array.from", "Set", "Symbol")
 * - Object.isExtensible, License: CC0 (required by "URL", "Array.from", "Map")
 * - Object.keys, License: MIT (required by "URL", "Array.from", "Set", "Symbol", "Object.getOwnPropertyNames")
 * - Object.getOwnPropertyNames, License: CC0 (required by "URL", "Array.from", "Set", "Symbol")
 * - Symbol, License: MIT (required by "URL", "Array.from", "Set", "Symbol.species")
 * - Symbol.iterator, License: MIT (required by "URL", "Array.from", "Set")
 * - _ESAbstract.GetIterator, License: CC0 (required by "URL", "Array.from", "Set")
 * - Symbol.species, License: MIT (required by "URL", "Array.from", "Set")
 * - Map, License: CC0 (required by "URL", "Array.from")
 * - Set, License: CC0 (required by "URL", "Array.from")
 * - Array.from, License: CC0 (required by "URL")
 * - URL, License: CC0-1.0 (required by "URL.prototype.toJSON")
 * - URL.prototype.toJSON, License: MIT */

(function(self, undefined) {

    // _ESAbstract.ArrayCreate
    // 9.4.2.2. ArrayCreate ( length [ , proto ] )
    function ArrayCreate(length /* [, proto] */) { // eslint-disable-line no-unused-vars
        // 1. Assert: length is an integer Number ≥ 0.
        // 2. If length is -0, set length to +0.
        if (1 / length === -Infinity) {
            length = 0;
        }
        // 3. If length>2^32-1, throw a RangeError exception.
        if (length > (Math.pow(2, 32) - 1)) {
            throw new RangeError('Invalid array length');
        }
        // 4. If proto is not present, set proto to the intrinsic object %ArrayPrototype%.
        // 5. Let A be a newly created Array exotic object.
        var A = [];
        // 6. Set A's essential internal methods except for [[DefineOwnProperty]] to the default ordinary object definitions specified in 9.1.
        // 7. Set A.[[DefineOwnProperty]] as specified in 9.4.2.1.
        // 8. Set A.[[Prototype]] to proto.
        // 9. Set A.[[Extensible]] to true.
        // 10. Perform ! OrdinaryDefineOwnProperty(A, "length", PropertyDescriptor{[[Value]]: length, [[Writable]]: true, [[Enumerable]]: false, [[Configurable]]: false}).
        A.length = length;
        // 11. Return A.
        return A;
    }
    
    // _ESAbstract.Call
    /* global IsCallable */
    // 7.3.12. Call ( F, V [ , argumentsList ] )
    function Call(F, V /* [, argumentsList] */) { // eslint-disable-line no-unused-vars
        // 1. If argumentsList is not present, set argumentsList to a new empty List.
        var argumentsList = arguments.length > 2 ? arguments[2] : [];
        // 2. If IsCallable(F) is false, throw a TypeError exception.
        if (IsCallable(F) === false) {
            throw new TypeError(Object.prototype.toString.call(F) + 'is not a function.');
        }
        // 3. Return ? F.[[Call]](V, argumentsList).
        return F.apply(V, argumentsList);
    }
    
    // _ESAbstract.CreateDataProperty
    // 7.3.4. CreateDataProperty ( O, P, V )
    // NOTE
    // This abstract operation creates a property whose attributes are set to the same defaults used for properties created by the ECMAScript language assignment operator.
    // Normally, the property will not already exist. If it does exist and is not configurable or if O is not extensible, [[DefineOwnProperty]] will return false.
    function CreateDataProperty(O, P, V) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: IsPropertyKey(P) is true.
        // 3. Let newDesc be the PropertyDescriptor{ [[Value]]: V, [[Writable]]: true, [[Enumerable]]: true, [[Configurable]]: true }.
        var newDesc = {
            value: V,
            writable: true,
            enumerable: true,
            configurable: true
        };
        // 4. Return ? O.[[DefineOwnProperty]](P, newDesc).
        try {
            Object.defineProperty(O, P, newDesc);
            return true;
        } catch (e) {
            return false;
        }
    }
    
    // _ESAbstract.CreateDataPropertyOrThrow
    /* global CreateDataProperty */
    // 7.3.6. CreateDataPropertyOrThrow ( O, P, V )
    function CreateDataPropertyOrThrow(O, P, V) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: IsPropertyKey(P) is true.
        // 3. Let success be ? CreateDataProperty(O, P, V).
        var success = CreateDataProperty(O, P, V);
        // 4. If success is false, throw a TypeError exception.
        if (!success) {
            throw new TypeError('Cannot assign value `' + Object.prototype.toString.call(V) + '` to property `' + Object.prototype.toString.call(P) + '` on object `' + Object.prototype.toString.call(O) + '`');
        }
        // 5. Return success.
        return success;
    }
    
    // _ESAbstract.CreateMethodProperty
    // 7.3.5. CreateMethodProperty ( O, P, V )
    function CreateMethodProperty(O, P, V) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: IsPropertyKey(P) is true.
        // 3. Let newDesc be the PropertyDescriptor{[[Value]]: V, [[Writable]]: true, [[Enumerable]]: false, [[Configurable]]: true}.
        var newDesc = {
            value: V,
            writable: true,
            enumerable: false,
            configurable: true
        };
        // 4. Return ? O.[[DefineOwnProperty]](P, newDesc).
        Object.defineProperty(O, P, newDesc);
    }
    
    // _ESAbstract.Get
    // 7.3.1. Get ( O, P )
    function Get(O, P) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: IsPropertyKey(P) is true.
        // 3. Return ? O.[[Get]](P, O).
        return O[P];
    }
    
    // _ESAbstract.HasOwnProperty
    // 7.3.11 HasOwnProperty (O, P)
    function HasOwnProperty(o, p) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: IsPropertyKey(P) is true.
        // 3. Let desc be ? O.[[GetOwnProperty]](P).
        // 4. If desc is undefined, return false.
        // 5. Return true.
        // Polyfill.io - As we expect user agents to support ES3 fully we can skip the above steps and use Object.prototype.hasOwnProperty to do them for us.
        return Object.prototype.hasOwnProperty.call(o, p);
    }
    
    // _ESAbstract.IsCallable
    // 7.2.3. IsCallable ( argument )
    function IsCallable(argument) { // eslint-disable-line no-unused-vars
        // 1. If Type(argument) is not Object, return false.
        // 2. If argument has a [[Call]] internal method, return true.
        // 3. Return false.
    
        // Polyfill.io - Only function objects have a [[Call]] internal method. This means we can simplify this function to check that the argument has a type of function.
        return typeof argument === 'function';
    }
    
    // _ESAbstract.SameValueNonNumber
    // 7.2.12. SameValueNonNumber ( x, y )
    function SameValueNonNumber(x, y) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(x) is not Number.
        // 2. Assert: Type(x) is the same as Type(y).
        // 3. If Type(x) is Undefined, return true.
        // 4. If Type(x) is Null, return true.
        // 5. If Type(x) is String, then
            // a. If x and y are exactly the same sequence of code units (same length and same code units at corresponding indices), return true; otherwise, return false.
        // 6. If Type(x) is Boolean, then
            // a. If x and y are both true or both false, return true; otherwise, return false.
        // 7. If Type(x) is Symbol, then
            // a. If x and y are both the same Symbol value, return true; otherwise, return false.
        // 8. If x and y are the same Object value, return true. Otherwise, return false.
    
        // Polyfill.io - We can skip all above steps because the === operator does it all for us.
        return x === y;
    }
    
    // _ESAbstract.ToBoolean
    // 7.1.2. ToBoolean ( argument )
    // The abstract operation ToBoolean converts argument to a value of type Boolean according to Table 9:
    /*
    --------------------------------------------------------------------------------------------------------------
    | Argument Type | Result                                                                                     |
    --------------------------------------------------------------------------------------------------------------
    | Undefined     | Return false.                                                                              |
    | Null          | Return false.                                                                              |
    | Boolean       | Return argument.                                                                           |
    | Number        | If argument is +0, -0, or NaN, return false; otherwise return true.                        |
    | String        | If argument is the empty String (its length is zero), return false; otherwise return true. |
    | Symbol        | Return true.                                                                               |
    | Object        | Return true.                                                                               |
    --------------------------------------------------------------------------------------------------------------
    */
    function ToBoolean(argument) { // eslint-disable-line no-unused-vars
        return Boolean(argument);
    }
    
    // _ESAbstract.ToObject
    // 7.1.13 ToObject ( argument )
    // The abstract operation ToObject converts argument to a value of type Object according to Table 12:
    // Table 12: ToObject Conversions
    /*
    |----------------------------------------------------------------------------------------------------------------------------------------------------|
    | Argument Type | Result                                                                                                                             |
    |----------------------------------------------------------------------------------------------------------------------------------------------------|
    | Undefined     | Throw a TypeError exception.                                                                                                       |
    | Null          | Throw a TypeError exception.                                                                                                       |
    | Boolean       | Return a new Boolean object whose [[BooleanData]] internal slot is set to argument. See 19.3 for a description of Boolean objects. |
    | Number        | Return a new Number object whose [[NumberData]] internal slot is set to argument. See 20.1 for a description of Number objects.    |
    | String        | Return a new String object whose [[StringData]] internal slot is set to argument. See 21.1 for a description of String objects.    |
    | Symbol        | Return a new Symbol object whose [[SymbolData]] internal slot is set to argument. See 19.4 for a description of Symbol objects.    |
    | Object        | Return argument.                                                                                                                   |
    |----------------------------------------------------------------------------------------------------------------------------------------------------|
    */
    function ToObject(argument) { // eslint-disable-line no-unused-vars
        if (argument === null || argument === undefined) {
            throw TypeError();
        }
        return Object(argument);
    }
    
    // _ESAbstract.GetV
    /* global ToObject */
    // 7.3.2 GetV (V, P)
    function GetV(v, p) { // eslint-disable-line no-unused-vars
        // 1. Assert: IsPropertyKey(P) is true.
        // 2. Let O be ? ToObject(V).
        var o = ToObject(v);
        // 3. Return ? O.[[Get]](P, V).
        return o[p];
    }
    
    // _ESAbstract.GetMethod
    /* global GetV, IsCallable */
    // 7.3.9. GetMethod ( V, P )
    function GetMethod(V, P) { // eslint-disable-line no-unused-vars
        // 1. Assert: IsPropertyKey(P) is true.
        // 2. Let func be ? GetV(V, P).
        var func = GetV(V, P);
        // 3. If func is either undefined or null, return undefined.
        if (func === null || func === undefined) {
            return undefined;
        }
        // 4. If IsCallable(func) is false, throw a TypeError exception.
        if (IsCallable(func) === false) {
            throw new TypeError('Method not callable: ' + P);
        }
        // 5. Return func.
        return func;
    }
    
    // _ESAbstract.Type
    // "Type(x)" is used as shorthand for "the type of x"...
    function Type(x) { // eslint-disable-line no-unused-vars
        switch (typeof x) {
            case 'undefined':
                return 'undefined';
            case 'boolean':
                return 'boolean';
            case 'number':
                return 'number';
            case 'string':
                return 'string';
            case 'symbol':
                return 'symbol';
            default:
                // typeof null is 'object'
                if (x === null) return 'null';
                // Polyfill.io - This is here because a Symbol polyfill will have a typeof `object`.
                if ('Symbol' in self && (x instanceof self.Symbol || x.constructor === self.Symbol)) return 'symbol';
    
                return 'object';
        }
    }
    
    // _ESAbstract.CreateIterResultObject
    /* global Type, CreateDataProperty */
    // 7.4.7. CreateIterResultObject ( value, done )
    function CreateIterResultObject(value, done) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(done) is Boolean.
        if (Type(done) !== 'boolean') {
            throw new Error();
        }
        // 2. Let obj be ObjectCreate(%ObjectPrototype%).
        var obj = {};
        // 3. Perform CreateDataProperty(obj, "value", value).
        CreateDataProperty(obj, "value", value);
        // 4. Perform CreateDataProperty(obj, "done", done).
        CreateDataProperty(obj, "done", done);
        // 5. Return obj.
        return obj;
    }
    
    // _ESAbstract.GetPrototypeFromConstructor
    /* global Get, Type */
    // 9.1.14. GetPrototypeFromConstructor ( constructor, intrinsicDefaultProto )
    function GetPrototypeFromConstructor(constructor, intrinsicDefaultProto) { // eslint-disable-line no-unused-vars
        // 1. Assert: intrinsicDefaultProto is a String value that is this specification's name of an intrinsic object. The corresponding object must be an intrinsic that is intended to be used as the [[Prototype]] value of an object.
        // 2. Assert: IsCallable(constructor) is true.
        // 3. Let proto be ? Get(constructor, "prototype").
        var proto = Get(constructor, "prototype");
        // 4. If Type(proto) is not Object, then
        if (Type(proto) !== 'object') {
            // a. Let realm be ? GetFunctionRealm(constructor).
            // b. Set proto to realm's intrinsic object named intrinsicDefaultProto.
            proto = intrinsicDefaultProto;
        }
        // 5. Return proto.
        return proto;
    }
    
    // _ESAbstract.OrdinaryCreateFromConstructor
    /* global GetPrototypeFromConstructor */
    // 9.1.13. OrdinaryCreateFromConstructor ( constructor, intrinsicDefaultProto [ , internalSlotsList ] )
    function OrdinaryCreateFromConstructor(constructor, intrinsicDefaultProto) { // eslint-disable-line no-unused-vars
        var internalSlotsList = arguments[2] || {};
        // 1. Assert: intrinsicDefaultProto is a String value that is this specification's name of an intrinsic object.
        // The corresponding object must be an intrinsic that is intended to be used as the[[Prototype]] value of an object.
    
        // 2. Let proto be ? GetPrototypeFromConstructor(constructor, intrinsicDefaultProto).
        var proto = GetPrototypeFromConstructor(constructor, intrinsicDefaultProto);
    
        // 3. Return ObjectCreate(proto, internalSlotsList).
        // Polyfill.io - We do not pass internalSlotsList to Object.create because Object.create does not use the default ordinary object definitions specified in 9.1.
        var obj = Object.create(proto);
        for (var name in internalSlotsList) {
            if (Object.prototype.hasOwnProperty.call(internalSlotsList, name)) {
                Object.defineProperty(obj, name, {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: internalSlotsList[name]
                });
            }
        }
        return obj;
    }
    
    // _ESAbstract.IsConstructor
    /* global Type */
    // 7.2.4. IsConstructor ( argument )
    function IsConstructor(argument) { // eslint-disable-line no-unused-vars
        // 1. If Type(argument) is not Object, return false.
        if (Type(argument) !== 'object') {
            return false;
        }
        // 2. If argument has a [[Construct]] internal method, return true.
        // 3. Return false.
    
        // Polyfill.io - `new argument` is the only way  to truly test if a function is a constructor.
        // We choose to not use`new argument` because the argument could have side effects when called.
        // Instead we check to see if the argument is a function and if it has a prototype.
        // Arrow functions do not have a [[Construct]] internal method, nor do they have a prototype.
        return typeof argument === 'function' && !!argument.prototype;
    }
    
    // _ESAbstract.Construct
    /* global IsConstructor, OrdinaryCreateFromConstructor, Call */
    // 7.3.13. Construct ( F [ , argumentsList [ , newTarget ]] )
    function Construct(F /* [ , argumentsList [ , newTarget ]] */) { // eslint-disable-line no-unused-vars
        // 1. If newTarget is not present, set newTarget to F.
        var newTarget = arguments.length > 2 ? arguments[2] : F;
    
        // 2. If argumentsList is not present, set argumentsList to a new empty List.
        var argumentsList = arguments.length > 1 ? arguments[1] : [];
    
        // 3. Assert: IsConstructor(F) is true.
        if (!IsConstructor(F)) {
            throw new TypeError('F must be a constructor.');
        }
    
        // 4. Assert: IsConstructor(newTarget) is true.
        if (!IsConstructor(newTarget)) {
            throw new TypeError('newTarget must be a constructor.');
        }
    
        // 5. Return ? F.[[Construct]](argumentsList, newTarget).
        // Polyfill.io - If newTarget is the same as F, it is equivalent to new F(...argumentsList).
        if (newTarget === F) {
            return new (Function.prototype.bind.apply(F, [null].concat(argumentsList)))();
        } else {
            // Polyfill.io - This is mimicking section 9.2.2 step 5.a.
            var obj = OrdinaryCreateFromConstructor(newTarget, Object.prototype);
            return Call(F, obj, argumentsList);
        }
    }
    
    // _ESAbstract.IteratorClose
    /* global GetMethod, Type, Call */
    // 7.4.6. IteratorClose ( iteratorRecord, completion )
    function IteratorClose(iteratorRecord, completion) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(iteratorRecord.[[Iterator]]) is Object.
        if (Type(iteratorRecord['[[Iterator]]']) !== 'object') {
            throw new Error(Object.prototype.toString.call(iteratorRecord['[[Iterator]]']) + 'is not an Object.');
        }
        // 2. Assert: completion is a Completion Record.
        // Polyfill.io - Ignoring this step as there is no way to check if something is a Completion Record in userland JavaScript.
    
        // 3. Let iterator be iteratorRecord.[[Iterator]].
        var iterator = iteratorRecord['[[Iterator]]'];
        // 4. Let return be ? GetMethod(iterator, "return").
        // Polyfill.io - We name it  returnMethod because return is a keyword and can not be used as an identifier (E.G. variable name, function name etc).
        var returnMethod = GetMethod(iterator, "return");
        // 5. If return is undefined, return Completion(completion).
        if (returnMethod === undefined) {
            return completion;
        }
        // 6. Let innerResult be Call(return, iterator, « »).
        try {
            var innerResult = Call(returnMethod, iterator);
        } catch (error) {
            var innerException = error;
        }
        // 7. If completion.[[Type]] is throw, return Completion(completion).
        if (completion) {
            return completion;
        }
        // 8. If innerResult.[[Type]] is throw, return Completion(innerResult).
        if (innerException) {
            throw innerException;
        }
        // 9. If Type(innerResult.[[Value]]) is not Object, throw a TypeError exception.
        if (Type(innerResult) !== 'object') {
            throw new TypeError("Iterator's return method returned a non-object.");
        }
        // 10. Return Completion(completion).
        return completion;
    }
    
    // _ESAbstract.IteratorComplete
    /* global Type, ToBoolean, Get */
    // 7.4.3 IteratorComplete ( iterResult )
    function IteratorComplete(iterResult) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(iterResult) is Object.
        if (Type(iterResult) !== 'object') {
            throw new Error(Object.prototype.toString.call(iterResult) + 'is not an Object.');
        }
        // 2. Return ToBoolean(? Get(iterResult, "done")).
        return ToBoolean(Get(iterResult, "done"));
    }
    
    // _ESAbstract.IteratorNext
    /* global Call, Type */
    // 7.4.2. IteratorNext ( iteratorRecord [ , value ] )
    function IteratorNext(iteratorRecord /* [, value] */) { // eslint-disable-line no-unused-vars
        // 1. If value is not present, then
        if (arguments.length < 2) {
            // a. Let result be ? Call(iteratorRecord.[[NextMethod]], iteratorRecord.[[Iterator]], « »).
            var result = Call(iteratorRecord['[[NextMethod]]'], iteratorRecord['[[Iterator]]']);
        // 2. Else,
        } else {
            // a. Let result be ? Call(iteratorRecord.[[NextMethod]], iteratorRecord.[[Iterator]], « value »).
            result = Call(iteratorRecord['[[NextMethod]]'], iteratorRecord['[[Iterator]]'], [arguments[1]]);
        }
        // 3. If Type(result) is not Object, throw a TypeError exception.
        if (Type(result) !== 'object') {
            throw new TypeError('bad iterator');
        }
        // 4. Return result.
        return result;
    }
    
    // _ESAbstract.IteratorStep
    /* global IteratorNext, IteratorComplete */
    // 7.4.5. IteratorStep ( iteratorRecord )
    function IteratorStep(iteratorRecord) { // eslint-disable-line no-unused-vars
        // 1. Let result be ? IteratorNext(iteratorRecord).
        var result = IteratorNext(iteratorRecord);
        // 2. Let done be ? IteratorComplete(result).
        var done = IteratorComplete(result);
        // 3. If done is true, return false.
        if (done === true) {
            return false;
        }
        // 4. Return result.
        return result;
    }
    
    // _ESAbstract.IteratorValue
    /* global Type, Get */
    // 7.4.4 IteratorValue ( iterResult )
    function IteratorValue(iterResult) { // eslint-disable-line no-unused-vars
        // Assert: Type(iterResult) is Object.
        if (Type(iterResult) !== 'object') {
            throw new Error(Object.prototype.toString.call(iterResult) + 'is not an Object.');
        }
        // Return ? Get(iterResult, "value").
        return Get(iterResult, "value");
    }
    
    // _ESAbstract.OrdinaryToPrimitive
    /* global Get, IsCallable, Call, Type */
    // 7.1.1.1. OrdinaryToPrimitive ( O, hint )
    function OrdinaryToPrimitive(O, hint) { // eslint-disable-line no-unused-vars
        // 1. Assert: Type(O) is Object.
        // 2. Assert: Type(hint) is String and its value is either "string" or "number".
        // 3. If hint is "string", then
        if (hint === 'string') {
            // a. Let methodNames be « "toString", "valueOf" ».
            var methodNames = ['toString', 'valueOf'];
            // 4. Else,
        } else {
            // a. Let methodNames be « "valueOf", "toString" ».
            methodNames = ['valueOf', 'toString'];
        }
        // 5. For each name in methodNames in List order, do
        for (var i = 0; i < methodNames.length; ++i) {
            var name = methodNames[i];
            // a. Let method be ? Get(O, name).
            var method = Get(O, name);
            // b. If IsCallable(method) is true, then
            if (IsCallable(method)) {
                // i. Let result be ? Call(method, O).
                var result = Call(method, O);
                // ii. If Type(result) is not Object, return result.
                if (Type(result) !== 'object') {
                    return result;
                }
            }
        }
        // 6. Throw a TypeError exception.
        throw new TypeError('Cannot convert to primitive.');
    }
    
    // _ESAbstract.SameValueZero
    /* global Type, SameValueNonNumber */
    // 7.2.11. SameValueZero ( x, y )
    function SameValueZero (x, y) { // eslint-disable-line no-unused-vars
        // 1. If Type(x) is different from Type(y), return false.
        if (Type(x) !== Type(y)) {
            return false;
        }
        // 2. If Type(x) is Number, then
        if (Type(x) === 'number') {
            // a. If x is NaN and y is NaN, return true.
            if (isNaN(x) && isNaN(y)) {
                return true;
            }
            // b. If x is +0 and y is -0, return true.
            if (1/x === Infinity && 1/y === -Infinity) {
                return true;
            }
            // c. If x is -0 and y is +0, return true.
            if (1/x === -Infinity && 1/y === Infinity) {
                return true;
            }
            // d. If x is the same Number value as y, return true.
            if (x === y) {
                return true;
            }
            // e. Return false.
            return false;
        }
        // 3. Return SameValueNonNumber(x, y).
        return SameValueNonNumber(x, y);
    }
    
    // _ESAbstract.ToInteger
    /* global Type */
    // 7.1.4. ToInteger ( argument )
    function ToInteger(argument) { // eslint-disable-line no-unused-vars
        if (Type(argument) === 'symbol') {
            throw new TypeError('Cannot convert a Symbol value to a number');
        }
    
        // 1. Let number be ? ToNumber(argument).
        var number = Number(argument);
        // 2. If number is NaN, return +0.
        if (isNaN(number)) {
            return 0;
        }
        // 3. If number is +0, -0, +∞, or -∞, return number.
        if (1/number === Infinity || 1/number === -Infinity || number === Infinity || number === -Infinity) {
            return number;
        }
        // 4. Return the number value that is the same sign as number and whose magnitude is floor(abs(number)).
        return ((number < 0) ? -1 : 1) * Math.floor(Math.abs(number));
    }
    
    // _ESAbstract.ToLength
    /* global ToInteger */
    // 7.1.15. ToLength ( argument )
    function ToLength(argument) { // eslint-disable-line no-unused-vars
        // 1. Let len be ? ToInteger(argument).
        var len = ToInteger(argument);
        // 2. If len ≤ +0, return +0.
        if (len <= 0) {
            return 0;
        }
        // 3. Return min(len, 253-1).
        return Math.min(len, Math.pow(2, 53) -1);
    }
    
    // _ESAbstract.ToPrimitive
    /* global Type, GetMethod, Call, OrdinaryToPrimitive */
    // 7.1.1. ToPrimitive ( input [ , PreferredType ] )
    function ToPrimitive(input /* [, PreferredType] */) { // eslint-disable-line no-unused-vars
        var PreferredType = arguments.length > 1 ? arguments[1] : undefined;
        // 1. Assert: input is an ECMAScript language value.
        // 2. If Type(input) is Object, then
        if (Type(input) === 'object') {
            // a. If PreferredType is not present, let hint be "default".
            if (arguments.length < 2) {
                var hint = 'default';
                // b. Else if PreferredType is hint String, let hint be "string".
            } else if (PreferredType === String) {
                hint = 'string';
                // c. Else PreferredType is hint Number, let hint be "number".
            } else if (PreferredType === Number) {
                hint = 'number';
            }
            // d. Let exoticToPrim be ? GetMethod(input, @@toPrimitive).
            var exoticToPrim = typeof self.Symbol === 'function' && typeof self.Symbol.toPrimitive === 'symbol' ? GetMethod(input, self.Symbol.toPrimitive) : undefined;
            // e. If exoticToPrim is not undefined, then
            if (exoticToPrim !== undefined) {
                // i. Let result be ? Call(exoticToPrim, input, « hint »).
                var result = Call(exoticToPrim, input, [hint]);
                // ii. If Type(result) is not Object, return result.
                if (Type(result) !== 'object') {
                    return result;
                }
                // iii. Throw a TypeError exception.
                throw new TypeError('Cannot convert exotic object to primitive.');
            }
            // f. If hint is "default", set hint to "number".
            if (hint === 'default') {
                hint = 'number';
            }
            // g. Return ? OrdinaryToPrimitive(input, hint).
            return OrdinaryToPrimitive(input, hint);
        }
        // 3. Return input
        return input;
    }
    
    // _ESAbstract.ToString
    /* global Type, ToPrimitive */
    // 7.1.12. ToString ( argument )
    // The abstract operation ToString converts argument to a value of type String according to Table 11:
    // Table 11: ToString Conversions
    /*
    |---------------|--------------------------------------------------------|
    | Argument Type | Result                                                 |
    |---------------|--------------------------------------------------------|
    | Undefined     | Return "undefined".                                    |
    |---------------|--------------------------------------------------------|
    | Null	        | Return "null".                                         |
    |---------------|--------------------------------------------------------|
    | Boolean       | If argument is true, return "true".                    |
    |               | If argument is false, return "false".                  |
    |---------------|--------------------------------------------------------|
    | Number        | Return NumberToString(argument).                       |
    |---------------|--------------------------------------------------------|
    | String        | Return argument.                                       |
    |---------------|--------------------------------------------------------|
    | Symbol        | Throw a TypeError exception.                           |
    |---------------|--------------------------------------------------------|
    | Object        | Apply the following steps:                             |
    |               | Let primValue be ? ToPrimitive(argument, hint String). |
    |               | Return ? ToString(primValue).                          |
    |---------------|--------------------------------------------------------|
    */
    function ToString(argument) { // eslint-disable-line no-unused-vars
        switch(Type(argument)) {
            case 'symbol':
                throw new TypeError('Cannot convert a Symbol value to a string');
            case 'object':
                var primValue = ToPrimitive(argument, String);
                return ToString(primValue); // eslint-disable-line no-unused-vars
            default:
                return String(argument);
        }
    }
    
    // _ESAbstract.ToPropertyKey
    /* globals ToPrimitive, Type, ToString */
    // 7.1.14. ToPropertyKey ( argument )
    function ToPropertyKey(argument) { // eslint-disable-line no-unused-vars
        // 1. Let key be ? ToPrimitive(argument, hint String).
        var key = ToPrimitive(argument, String);
        // 2. If Type(key) is Symbol, then
        if (Type(key) === 'symbol') {
            // a. Return key.
            return key;
        }
        // 3. Return ! ToString(key).
        return ToString(key);
    }
    
    // Array.prototype.includes
    /* global CreateMethodProperty, Get, SameValueZero, ToInteger, ToLength, ToObject, ToString */
    // 22.1.3.11. Array.prototype.includes ( searchElement [ , fromIndex ] )
    CreateMethodProperty(Array.prototype, 'includes', function includes(searchElement /* [ , fromIndex ] */) {
        'use strict';
        // 1. Let O be ? ToObject(this value).
        var O = ToObject(this);
        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = ToLength(Get(O, "length"));
        // 3. If len is 0, return false.
        if (len === 0) {
            return false;
        }
        // 4. Let n be ? ToInteger(fromIndex). (If fromIndex is undefined, this step produces the value 0.)
        var n = ToInteger(arguments[1]);
        // 5. If n ≥ 0, then
        if (n >= 0) {
            // a. Let k be n.
            var k = n;
            // 6. Else n < 0,
        } else {
            // a. Let k be len + n.
            k = len + n;
            // b. If k < 0, let k be 0.
            if (k < 0) {
                k = 0;
            }
        }
        // 7. Repeat, while k < len
        while (k < len) {
            // a. Let elementK be the result of ? Get(O, ! ToString(k)).
            var elementK = Get(O, ToString(k));
            // b. If SameValueZero(searchElement, elementK) is true, return true.
            if (SameValueZero(searchElement, elementK)) {
                return true;
            }
            // c. Increase k by 1.
            k = k + 1;
        }
        // 8. Return false.
        return false;
    });
    
    // Object.getOwnPropertyDescriptor
    /* global CreateMethodProperty, ToObject, ToPropertyKey, HasOwnProperty, Type */
    (function () {
        var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    
        var supportsDOMDescriptors = (function () {
            try {
                return Object.defineProperty(document.createElement('div'), 'one', {
                    get: function () {
                        return 1;
                    }
                }).one === 1;
            } catch (e) {
                return false;
            }
        });
    
        var toString = ({}).toString;
        var split = ''.split;
    
        // 19.1.2.8 Object.getOwnPropertyDescriptor ( O, P )
        CreateMethodProperty(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(O, P) {
            // 1. Let obj be ? ToObject(O).
            var obj = ToObject(O);
            // Polyfill.io fallback for non-array-like strings which exist in some ES3 user-agents (IE 8)
            obj = (Type(obj) === 'string' || obj instanceof String) && toString.call(O) == '[object String]' ? split.call(O, '') : Object(O);
    
            // 2. Let key be ? ToPropertyKey(P).
            var key = ToPropertyKey(P);
    
            // 3. Let desc be ? obj.[[GetOwnProperty]](key).
            // 4. Return FromPropertyDescriptor(desc).
            // Polyfill.io Internet Explorer 8 natively supports property descriptors only on DOM objects.
            // We will fallback to the polyfill implementation if the native implementation throws an error.
            if (supportsDOMDescriptors) {
                try {
                    return nativeGetOwnPropertyDescriptor(obj, key);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            }
            if (HasOwnProperty(obj, key)) {
                return {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: obj[key]
                };
            }
        });
    }());
    
    // Object.isExtensible
    /* global CreateMethodProperty, Type */
    
    (function (nativeIsExtensible) {
        // 19.1.2.13 Object.isExtensible ( O )
        CreateMethodProperty(Object, 'isExtensible', function isExtensible(O) {
            // 1. If Type(O) is not Object, return false.
            if (Type(O) !== "object") {
                return false;
            }
            // 2. Return ? IsExtensible(O).
            return nativeIsExtensible ? nativeIsExtensible(O) : true;
        });
    }(Object.isExtensible));
    
    // Object.keys
    /* global CreateMethodProperty */
    CreateMethodProperty(Object, "keys", (function() {
        'use strict';
    
        // modified from https://github.com/es-shims/object-keys
    
        var has = Object.prototype.hasOwnProperty;
        var toStr = Object.prototype.toString;
        var isEnumerable = Object.prototype.propertyIsEnumerable;
        var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
        var hasPrototypeEnumBug = isEnumerable.call(function () { }, 'prototype');
        function hasProtoEnumBug() {
            // Object.create polyfill creates an enumerable __proto__
            var createdObj;
            try {
                createdObj = Object.create({});
            } catch (e) {
                // If this fails the polyfil isn't loaded yet, but will be.
                // Can't add it to depedencies because of it would create a circular depedency.
                return true;
            }
    
            return isEnumerable.call(createdObj, '__proto__')
        }
    
        var dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var equalsConstructorPrototype = function (o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var excludedKeys = {
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var hasAutomationEqualityBug = (function () {
            if (typeof window === 'undefined') { return false; }
            for (var k in window) {
                try {
                    if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
                        try {
                            equalsConstructorPrototype(window[k]);
                        } catch (e) {
                            return true;
                        }
                    }
                } catch (e) {
                    return true;
                }
            }
            return false;
        }());
        var equalsConstructorPrototypeIfNotBuggy = function (o) {
            if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
                return equalsConstructorPrototype(o);
            }
            try {
                return equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
    
        function isArgumentsObject(value) {
            var str = toStr.call(value);
            var isArgs = str === '[object Arguments]';
            if (!isArgs) {
                isArgs = str !== '[object Array]' &&
                    value !== null &&
                    typeof value === 'object' &&
                    typeof value.length === 'number' &&
                    value.length >= 0 &&
                    toStr.call(value.callee) === '[object Function]';
            }
            return isArgs;
        }
    
        return function keys(object) {
            var isFunction = toStr.call(object) === '[object Function]';
            var isArguments = isArgumentsObject(object);
            var isString = toStr.call(object) === '[object String]';
            var theKeys = [];
    
            if (object === undefined || object === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }
    
            var skipPrototype = hasPrototypeEnumBug && isFunction;
            if (isString && object.length > 0 && !has.call(object, 0)) {
                for (var i = 0; i < object.length; ++i) {
                    theKeys.push(String(i));
                }
            }
    
            if (isArguments && object.length > 0) {
                for (var j = 0; j < object.length; ++j) {
                    theKeys.push(String(j));
                }
            } else {
                for (var name in object) {
                    if (!(hasProtoEnumBug() && name === '__proto__') && !(skipPrototype && name === 'prototype') && has.call(object, name)) {
                        theKeys.push(String(name));
                    }
                }
            }
    
            if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
    
                for (var k = 0; k < dontEnums.length; ++k) {
                    if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
                        theKeys.push(dontEnums[k]);
                    }
                }
            }
            return theKeys;
        };
    }()));
    
    // Object.getOwnPropertyNames
    /* global CreateMethodProperty, ToObject */
    (function() {
        var toString = {}.toString;
        var split = "".split;
        var concat = [].concat;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var nativeGetOwnPropertyNames = Object.getOwnPropertyNames || Object.keys;
        var cachedWindowNames =
            typeof self === "object" ? nativeGetOwnPropertyNames(self) : [];
    
        // 19.1.2.10 Object.getOwnPropertyNames ( O )
        CreateMethodProperty(
            Object,
            "getOwnPropertyNames",
            function getOwnPropertyNames(O) {
                var object = ToObject(O);
    
                if (toString.call(object) === "[object Window]") {
                    try {
                        return nativeGetOwnPropertyNames(object);
                    } catch (e) {
                        // IE bug where layout engine calls userland Object.getOwnPropertyNames for cross-domain `window` objects
                        return concat.call([], cachedWindowNames);
                    }
                }
    
                // Polyfill.io fallback for non-array-like strings which exist in some ES3 user-agents (IE 8)
                object =
                    toString.call(object) == "[object String]"
                        ? split.call(object, "")
                        : Object(object);
    
                var result = nativeGetOwnPropertyNames(object);
                var extraNonEnumerableKeys = ["length", "prototype"];
                for (var i = 0; i < extraNonEnumerableKeys.length; i++) {
                    var key = extraNonEnumerableKeys[i];
                    if (hasOwnProperty.call(object, key) && !result.includes(key)) {
                        result.push(key);
                    }
                }
    
                if (result.includes("__proto__")) {
                    var index = result.indexOf("__proto__");
                    result.splice(index, 1);
                }
    
                return result;
            }
        );
    })();
    
    // Symbol
    // A modification of https://github.com/WebReflection/get-own-property-symbols
    // (C) Andrea Giammarchi - MIT Licensed
    
    /* global Type */
    (function (Object,  GOPS, global) {
        'use strict'; //so that ({}).toString.call(null) returns the correct [object Null] rather than [object Window]
    
        var supportsGetters = (function () {
            // supports getters
            try {
                var a = {};
                Object.defineProperty(a, "t", {
                    configurable: true,
                    enumerable: false,
                    get: function () {
                        return true;
                    },
                    set: undefined
                });
                return !!a.t;
            } catch (e) {
                return false;
            }
        }());
    
        var	setDescriptor;
        var id = 0;
        var random = '' + Math.random();
        var prefix = '__\x01symbol:';
        var prefixLength = prefix.length;
        var internalSymbol = '__\x01symbol@@' + random;
        var emptySymbolLookup = {};
        var DP = 'defineProperty';
        var DPies = 'defineProperties';
        var GOPN = 'getOwnPropertyNames';
        var GOPD = 'getOwnPropertyDescriptor';
        var PIE = 'propertyIsEnumerable';
        var ObjectProto = Object.prototype;
        var hOP = ObjectProto.hasOwnProperty;
        var pIE = ObjectProto[PIE];
        var toString = ObjectProto.toString;
        var concat = Array.prototype.concat;
        var cachedWindowNames = Object.getOwnPropertyNames ? Object.getOwnPropertyNames(self) : [];
        var nGOPN = Object[GOPN];
        var gOPN = function getOwnPropertyNames (obj) {
            if (toString.call(obj) === '[object Window]') {
                try {
                    return nGOPN(obj);
                } catch (e) {
                    // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
                    return concat.call([], cachedWindowNames);
                }
            }
            return nGOPN(obj);
        };
        var gOPD = Object[GOPD];
        var objectCreate = Object.create;
        var objectKeys = Object.keys;
        var freeze = Object.freeze || Object;
        var objectDefineProperty = Object[DP];
        var $defineProperties = Object[DPies];
        var descriptor = gOPD(Object, GOPN);
        var addInternalIfNeeded = function (o, uid, enumerable) {
            if (!hOP.call(o, internalSymbol)) {
                try {
                    objectDefineProperty(o, internalSymbol, {
                        enumerable: false,
                        configurable: false,
                        writable: false,
                        value: {}
                    });
                } catch (e) {
                    o[internalSymbol] = {};
                }
            }
            o[internalSymbol]['@@' + uid] = enumerable;
        };
        var createWithSymbols = function (proto, descriptors) {
            var self = objectCreate(proto);
            gOPN(descriptors).forEach(function (key) {
                if (propertyIsEnumerable.call(descriptors, key)) {
                    $defineProperty(self, key, descriptors[key]);
                }
            });
            return self;
        };
        var copyAsNonEnumerable = function (descriptor) {
            var newDescriptor = objectCreate(descriptor);
            newDescriptor.enumerable = false;
            return newDescriptor;
        };
        var get = function get(){};
        var onlyNonSymbols = function (name) {
            return name != internalSymbol &&
                !hOP.call(source, name);
        };
        var onlySymbols = function (name) {
            return name != internalSymbol &&
                hOP.call(source, name);
        };
        var propertyIsEnumerable = function propertyIsEnumerable(key) {
            var uid = '' + key;
            return onlySymbols(uid) ? (
                hOP.call(this, uid) &&
                this[internalSymbol] && this[internalSymbol]['@@' + uid]
            ) : pIE.call(this, key);
        };
        var setAndGetSymbol = function (uid) {
            var descriptor = {
                enumerable: false,
                configurable: true,
                get: get,
                set: function (value) {
                setDescriptor(this, uid, {
                    enumerable: false,
                    configurable: true,
                    writable: true,
                    value: value
                });
                addInternalIfNeeded(this, uid, true);
                }
            };
            try {
                objectDefineProperty(ObjectProto, uid, descriptor);
            } catch (e) {
                ObjectProto[uid] = descriptor.value;
            }
            source[uid] = objectDefineProperty(
                Object(uid),
                'constructor',
                sourceConstructor
            );
            var description = gOPD(Symbol.prototype, 'description');
            if (description) {
                objectDefineProperty(
                    source[uid],
                    'description',
                    description
                );
            }
            return freeze(source[uid]);
        };
    
        var symbolDescription = function (s) {
            var sym = thisSymbolValue(s);
    
            // 3. Return sym.[[Description]].
            if (supportsInferredNames) {
                var name = getInferredName(sym);
                if (name !== "") {
                    return name.slice(1, -1); // name.slice('['.length, -']'.length);
                }
            }
    
            if (emptySymbolLookup[sym] !== undefined) {
                return emptySymbolLookup[sym];
            }
    
            var string = sym.toString();
            var randomStartIndex = string.lastIndexOf("0.");
            string = string.slice(10, randomStartIndex);
    
            if (string === "") {
                return undefined;
            }
            return string;
        };
    
        var Symbol = function Symbol() {
            var description = arguments[0];
            if (this instanceof Symbol) {
                throw new TypeError('Symbol is not a constructor');
            }
    
            var uid = prefix.concat(description || '', random, ++id);
    
            if (description !== undefined && (description === null || isNaN(description) || String(description) === "")) {
                emptySymbolLookup[uid] = String(description);
            }
    
            var that = setAndGetSymbol(uid);
    
            if (!supportsGetters) {
                Object.defineProperty(that, "description", {
                    configurable: true,
                    enumerable: false,
                    value: symbolDescription(that)
                });
            }
    
            return that;
        };
    
        var source = objectCreate(null);
        var sourceConstructor = {value: Symbol};
        var sourceMap = function (uid) {
            return source[uid];
            };
        var $defineProperty = function defineProperty(o, key, descriptor) {
            var uid = '' + key;
            if (onlySymbols(uid)) {
                setDescriptor(o, uid, descriptor.enumerable ?
                    copyAsNonEnumerable(descriptor) : descriptor);
                addInternalIfNeeded(o, uid, !!descriptor.enumerable);
            } else {
                objectDefineProperty(o, key, descriptor);
            }
            return o;
        };
    
        var onlyInternalSymbols = function (obj) {
            return function (name) {
                return hOP.call(obj, internalSymbol) && hOP.call(obj[internalSymbol], '@@' + name);
            };
        };
        var $getOwnPropertySymbols = function getOwnPropertySymbols(o) {
            return gOPN(o).filter(o === ObjectProto ? onlyInternalSymbols(o) : onlySymbols).map(sourceMap);
            }
        ;
    
        descriptor.value = $defineProperty;
        objectDefineProperty(Object, DP, descriptor);
    
        descriptor.value = $getOwnPropertySymbols;
        objectDefineProperty(Object, GOPS, descriptor);
    
        descriptor.value = function getOwnPropertyNames(o) {
            return gOPN(o).filter(onlyNonSymbols);
        };
        objectDefineProperty(Object, GOPN, descriptor);
    
        descriptor.value = function defineProperties(o, descriptors) {
            var symbols = $getOwnPropertySymbols(descriptors);
            if (symbols.length) {
            objectKeys(descriptors).concat(symbols).forEach(function (uid) {
                if (propertyIsEnumerable.call(descriptors, uid)) {
                $defineProperty(o, uid, descriptors[uid]);
                }
            });
            } else {
            $defineProperties(o, descriptors);
            }
            return o;
        };
        objectDefineProperty(Object, DPies, descriptor);
    
        descriptor.value = propertyIsEnumerable;
        objectDefineProperty(ObjectProto, PIE, descriptor);
    
        descriptor.value = Symbol;
        objectDefineProperty(global, 'Symbol', descriptor);
    
        // defining `Symbol.for(key)`
        descriptor.value = function (key) {
            var uid = prefix.concat(prefix, key, random);
            return uid in ObjectProto ? source[uid] : setAndGetSymbol(uid);
        };
        objectDefineProperty(Symbol, 'for', descriptor);
    
        // defining `Symbol.keyFor(symbol)`
        descriptor.value = function (symbol) {
            if (onlyNonSymbols(symbol))
            throw new TypeError(symbol + ' is not a symbol');
            return hOP.call(source, symbol) ?
            symbol.slice(prefixLength * 2, -random.length) :
            void 0
            ;
        };
        objectDefineProperty(Symbol, 'keyFor', descriptor);
    
        descriptor.value = function getOwnPropertyDescriptor(o, key) {
            var descriptor = gOPD(o, key);
            if (descriptor && onlySymbols(key)) {
            descriptor.enumerable = propertyIsEnumerable.call(o, key);
            }
            return descriptor;
        };
        objectDefineProperty(Object, GOPD, descriptor);
    
        descriptor.value = function create(proto, descriptors) {
            return arguments.length === 1 || typeof descriptors === "undefined" ?
            objectCreate(proto) :
            createWithSymbols(proto, descriptors);
        };
    
        objectDefineProperty(Object, 'create', descriptor);
    
        var strictModeSupported = (function(){ 'use strict'; return this; }).call(null) === null;
        if (strictModeSupported) {
            descriptor.value = function () {
                var str = toString.call(this);
                return (str === '[object String]' && onlySymbols(this)) ? '[object Symbol]' : str;
            };
        } else {
            descriptor.value = function () {
                // https://github.com/Financial-Times/polyfill-library/issues/164#issuecomment-486965300
                // Polyfill.io this code is here for the situation where a browser does not
                // support strict mode and is executing `Object.prototype.toString.call(null)`.
                // This code ensures that we return the correct result in that situation however,
                // this code also introduces a bug where it will return the incorrect result for
                // `Object.prototype.toString.call(window)`. We can't have the correct result for
                // both `window` and `null`, so we have opted for `null` as we believe this is the more
                // common situation.
                if (this === window) {
                    return '[object Null]';
                }
    
                var str = toString.call(this);
                return (str === '[object String]' && onlySymbols(this)) ? '[object Symbol]' : str;
            };
        }
        objectDefineProperty(ObjectProto, 'toString', descriptor);
    
        setDescriptor = function (o, key, descriptor) {
            var protoDescriptor = gOPD(ObjectProto, key);
            delete ObjectProto[key];
            objectDefineProperty(o, key, descriptor);
            if (o !== ObjectProto) {
                objectDefineProperty(ObjectProto, key, protoDescriptor);
            }
        };
    
        // The abstract operation thisSymbolValue(value) performs the following steps:
        function thisSymbolValue(value) {
            // 1. If Type(value) is Symbol, return value.
            if (Type(value) === "symbol") {
                return value;
            }
            // 2. If Type(value) is Object and value has a [[SymbolData]] internal slot, then
            // a. Let s be value.[[SymbolData]].
            // b. Assert: Type(s) is Symbol.
            // c. Return s.
            // 3. Throw a TypeError exception.
            throw TypeError(value + " is not a symbol");
        }
    
        // Symbol.prototype.description
        if (function () {
            // supports getters
            try {
                var a = {};
                Object.defineProperty(a, "t", {
                    configurable: true,
                    enumerable: false,
                    get: function() {
                        return true;
                    },
                    set: undefined
                });
                return !!a.t;
            } catch (e) {
                return false;
            }
        }()) {
            var getInferredName;
            try {
                // eslint-disable-next-line no-new-func
                getInferredName = Function("s", "var v = s.valueOf(); return { [v]() {} }[v].name;");
                // eslint-disable-next-line no-empty
            } catch (e) { }
    
            var inferred = function () { };
            var supportsInferredNames = getInferredName && inferred.name === "inferred" ? getInferredName : null;
    
    
            // 19.4.3.2 get Symbol.prototype.description
            Object.defineProperty(global.Symbol.prototype, "description", {
                configurable: true,
                enumerable: false,
                get: function () {
                    // 1. Let s be the this value.
                    var s = this;
                    return symbolDescription(s);
                }
            });
        }
    
    }(Object, 'getOwnPropertySymbols', self));
    
    // Symbol.iterator
    Object.defineProperty(self.Symbol, 'iterator', { value: self.Symbol('iterator') });
    
    // _ESAbstract.GetIterator
    /* global GetMethod, Symbol, Call, Type, GetV */
    // 7.4.1. GetIterator ( obj [ , method ] )
    // The abstract operation GetIterator with argument obj and optional argument method performs the following steps:
    function GetIterator(obj /*, method */) { // eslint-disable-line no-unused-vars
        // 1. If method is not present, then
            // a. Set method to ? GetMethod(obj, @@iterator).
        var method = arguments.length > 1 ? arguments[1] : GetMethod(obj, Symbol.iterator);
        // 2. Let iterator be ? Call(method, obj).
        var iterator = Call(method, obj);
        // 3. If Type(iterator) is not Object, throw a TypeError exception.
        if (Type(iterator) !== 'object') {
            throw new TypeError('bad iterator');
        }
        // 4. Let nextMethod be ? GetV(iterator, "next").
        var nextMethod = GetV(iterator, "next");
        // 5. Let iteratorRecord be Record {[[Iterator]]: iterator, [[NextMethod]]: nextMethod, [[Done]]: false}.
        var iteratorRecord = Object.create(null);
        iteratorRecord['[[Iterator]]'] = iterator;
        iteratorRecord['[[NextMethod]]'] = nextMethod;
        iteratorRecord['[[Done]]'] = false;
        // 6. Return iteratorRecord.
        return iteratorRecord;
    }
    
    // Symbol.species
    /* global Symbol */
    Object.defineProperty(Symbol, 'species', { value: Symbol('species') });
    
    // Map
    /* global CreateIterResultObject, CreateMethodProperty, GetIterator, IsCallable, IteratorClose, IteratorStep, IteratorValue, OrdinaryCreateFromConstructor, SameValueZero, Type, Symbol */
    (function (global) {
        var supportsGetters = (function () {
            try {
                var a = {};
                Object.defineProperty(a, 't', {
                    configurable: true,
                    enumerable: false,
                    get: function () {
                        return true;
                    },
                    set: undefined
                });
                return !!a.t;
            } catch (e) {
                return false;
            }
        }());
    
        // Need an internal counter to assign unique IDs to a key map
        var _uniqueHashId = 0;
        // Create a unique key name for storing meta data on functions and objects to enable lookups in hash table
        var _metaKey = Symbol('meta_' + ((Math.random() * 100000000) + '').replace('.', ''));
    
        /**
         * hashKey()
         * Function that given a key of `any` type, returns a string key value to enable hash map optimization for accessing Map data structure
         * @param {string|integer|function|object} recordKey - Record key to normalize to string accessor for hash map
         * @returns {string|false} - Returns a hashed string value or false if non extensible object key
         */
        var hashKey = function(recordKey) {
            // Check to see if we are dealing with object or function type.
            if (typeof recordKey === 'object' ? recordKey !== null : typeof recordKey === 'function') {
                // Check to see if we are dealing with a non extensible object
                if (!Object.isExtensible(recordKey)) {
                    // Return `false`
                    return false;
                }
                if (!Object.prototype.hasOwnProperty.call(recordKey, _metaKey)) {
                    var uniqueHashKey = typeof(recordKey)+'-'+(++_uniqueHashId);
                    Object.defineProperty(recordKey, _metaKey, {
                        configurable: false,
                        enumerable: false,
                        writable: false,
                        value: uniqueHashKey
                    });
                }
                // Return previously defined hashed key
                return recordKey[_metaKey];
            }
            // If this is just a primitive, we can cast it to a string and return it
            return ''+recordKey;
        };
    
        /**
         * getRecordIndex()
         * Function that given a Map and a key of `any` type, returns an index number that coorelates with a record found in `this._keys[index]` and `this._values[index]`
         * @param {Map} map - Map structure
         * @param {string|number|function|object} recordKey - Record key to normalize to string accessor for hash map
         * @returns {number|false} - Returns either a index to access map._keys and map._values, or false if not found
         */
        var getRecordIndex = function(map, recordKey) {
            var hashedKey = hashKey(recordKey); // Casts key to unique string (unless already string or number)
            if (hashedKey === false) {
                // We have to iterate through our Map structure because `recordKey` is non-primitive and not extensible
                return getRecordIndexSlow(map, recordKey);
            }
            var recordIndex = map._table[hashedKey]; // O(1) access to record
            return recordIndex !== undefined ? recordIndex : false;
        };
    
        /**
         * getRecordIndexSlow()
         * Alternative (and slower) function to `getRecordIndex()`.  Necessary for looking up non-extensible object keys.
         * @param {Map} map - Map structure
         * @param {string|number|function|object} recordKey - Record key to normalize to string accessor for hash map
         * @returns {number|false} - Returns either a index to access map._keys and map._values, or false if not found
         */
        var getRecordIndexSlow = function(map, recordKey) {
            // We have to iterate through our Map structure because `recordKey` is non-primitive and not extensible
            for (var i = 0; i < map._keys.length; i++) {
                var _recordKey = map._keys[i];
                if (_recordKey !== undefMarker && SameValueZero(_recordKey, recordKey)) {
                    return i;
                }
            }
            return false;
        };
    
        /**
         * setHashIndex()
         * Function that given a map, key of `any` type, and a value, creates a new entry in Map hash table
         * @param {Map} map
         * @param {string|number|function|object} recordKey - Key to translate into normalized key for hash map
         * @param {number|bool} recordIndex - new record index for the hashedKey or `false` to delete the record index for the hashedKey
         * @returns {bool} - indicates success of operation
         */
        var setHashIndex = function(map, recordKey, recordIndex) {
            var hashedKey = hashKey(recordKey);
            if (hashedKey === false) {
                // If hashed key is false, the recordKey is an object which is not extensible.
                // That indicates we cannot use the hash map for it, so this operation becomes no-op.
                return false;
            }
            if (recordIndex === false) {
                delete map._table[hashedKey];
            } else {
                map._table[hashedKey] = recordIndex;
            }
            return true;
        };
    
        // Deleted map items mess with iterator pointers, so rather than removing them mark them as deleted. Can't use undefined or null since those both valid keys so use a private symbol.
        var undefMarker = Symbol('undef');
        // 23.1.1.1 Map ( [ iterable ] )
        var Map = function Map(/* iterable */) {
            // 1. If NewTarget is undefined, throw a TypeError exception.
            if (!(this instanceof Map)) {
                throw new TypeError('Constructor Map requires "new"');
            }
            // 2. Let map be ? OrdinaryCreateFromConstructor(NewTarget, "%MapPrototype%", « [[MapData]] »).
            var map = OrdinaryCreateFromConstructor(this, Map.prototype, {
                _table: {}, // O(1) access table for retrieving records
                _keys: [],
                _values: [],
                _size: 0,
                _es6Map: true
            });
    
            // 3. Set map.[[MapData]] to a new empty List.
            // Polyfill.io - This step was done as part of step two.
    
            // Some old engines do not support ES5 getters/setters.  Since Map only requires these for the size property, we can fall back to setting the size property statically each time the size of the map changes.
            if (!supportsGetters) {
                Object.defineProperty(map, 'size', {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: 0
                });
            }
    
            // 4. If iterable is not present, let iterable be undefined.
            var iterable = arguments.length > 0 ? arguments[0] : undefined;
    
            // 5. If iterable is either undefined or null, return map.
            if (iterable === null || iterable === undefined) {
                return map;
            }
    
            // 6. Let adder be ? Get(map, "set").
            var adder = map.set;
    
            // 7. If IsCallable(adder) is false, throw a TypeError exception.
            if (!IsCallable(adder)) {
                throw new TypeError("Map.prototype.set is not a function");
            }
    
            // 8. Let iteratorRecord be ? GetIterator(iterable).
            try {
                var iteratorRecord = GetIterator(iterable);
                // 9. Repeat,
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    // a. Let next be ? IteratorStep(iteratorRecord).
                    var next = IteratorStep(iteratorRecord);
                    // b. If next is false, return map.
                    if (next === false) {
                        return map;
                    }
                    // c. Let nextItem be ? IteratorValue(next).
                    var nextItem = IteratorValue(next);
                    // d. If Type(nextItem) is not Object, then
                    if (Type(nextItem) !== 'object') {
                        // i. Let error be Completion{[[Type]]: throw, [[Value]]: a newly created TypeError object, [[Target]]: empty}.
                        try {
                            throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
                        } catch (error) {
                            // ii. Return ? IteratorClose(iteratorRecord, error).
                            return IteratorClose(iteratorRecord, error);
                        }
                    }
                    try {
                        // Polyfill.io - The try catch accounts for steps: f, h, and j.
    
                        // e. Let k be Get(nextItem, "0").
                        var k = nextItem[0];
                        // f. If k is an abrupt completion, return ? IteratorClose(iteratorRecord, k).
                        // g. Let v be Get(nextItem, "1").
                        var v = nextItem[1];
                        // h. If v is an abrupt completion, return ? IteratorClose(iteratorRecord, v).
                        // i. Let status be Call(adder, map, « k.[[Value]], v.[[Value]] »).
                        adder.call(map, k, v);
                    } catch (e) {
                        // j. If status is an abrupt completion, return ? IteratorClose(iteratorRecord, status).
                        return IteratorClose(iteratorRecord, e);
                    }
                }
            } catch (e) {
                // Polyfill.io - For user agents which do not have iteration methods on argument objects or arrays, we can special case those.
                if (Array.isArray(iterable) ||
                    Object.prototype.toString.call(iterable) === '[object Arguments]' ||
                    // IE 7 & IE 8 return '[object Object]' for the arguments object, we can detect by checking for the existence of the callee property
                    (!!iterable.callee)) {
                    var index;
                    var length = iterable.length;
                    for (index = 0; index < length; index++) {
                        adder.call(map, iterable[index][0], iterable[index][1]);
                    }
                }
            }
            return map;
        };
    
        // 23.1.2.1. Map.prototype
        // The initial value of Map.prototype is the intrinsic object %MapPrototype%.
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: false }.
        Object.defineProperty(Map, 'prototype', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: {}
        });
    
        // 23.1.2.2 get Map [ @@species ]
        if (supportsGetters) {
            Object.defineProperty(Map, Symbol.species, {
                configurable: true,
                enumerable: false,
                get: function () {
                    // 1. Return the this value.
                    return this;
                },
                set: undefined
            });
        } else {
            CreateMethodProperty(Map, Symbol.species, Map);
        }
    
        // 23.1.3.1 Map.prototype.clear ( )
        CreateMethodProperty(Map.prototype, 'clear', function clear() {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (Type(M) !== 'object') {
                    throw new TypeError('Method Map.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. Let entries be the List that is M.[[MapData]].
                var entries = M._keys;
                // 5. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                for (var i = 0; i < entries.length; i++) {
                    // 5.a. Set p.[[Key]] to empty.
                    M._keys[i] = undefMarker;
                    // 5.b. Set p.[[Value]] to empty.
                    M._values[i] = undefMarker;
                }
                this._size = 0;
                if (!supportsGetters) {
                    this.size = this._size;
                }
                // 5a. Clear lookup table
                this._table = {};
                // 6. Return undefined.
                return undefined;
            }
        );
    
        // 23.1.3.2. Map.prototype.constructor
        CreateMethodProperty(Map.prototype, 'constructor', Map);
    
        // 23.1.3.3. Map.prototype.delete ( key )
        CreateMethodProperty(Map.prototype, 'delete', function (key) {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (Type(M) !== 'object') {
                    throw new TypeError('Method Map.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. Let entries be the List that is M.[[MapData]].
                // 5. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                    // 5a. If p.[[Key]] is not empty and SameValueZero(p.[[Key]], key) is true, then
                        // i. Set p.[[Key]] to empty.
                        // ii. Set p.[[Value]] to empty.
                        // ii-a. Remove key from lookup table
                        // iii. Return true.
                // 6. Return false.
    
                // Implement steps 4-6 with a more optimal algo
    
                // Steps 4-5: Access record
                var recordIndex = getRecordIndex(M, key); // O(1) access to record index
    
                if (recordIndex !== false) {
                    // Get record's `key` (could be `any` type);
                    var recordKey = M._keys[recordIndex];
                    // 5a. If p.[[Key]] is not empty and SameValueZero(p.[[Key]], key) is true, then
                    if (recordKey !== undefMarker && SameValueZero(recordKey, key)) {
                        // i. Set p.[[Key]] to empty.
                        this._keys[recordIndex] = undefMarker;
                        // ii. Set p.[[Value]] to empty.
                        this._values[recordIndex] = undefMarker;
                        this._size = --this._size;
                        if (!supportsGetters) {
                            this.size = this._size;
                        }
                        // iia. Remove key from lookup table
                        setHashIndex(this, key, false);
                        // iii. Return true.
                        return true;
                    }
                }
    
                // 6. Return false.
                return false;
            }
        );
    
        // 23.1.3.4. Map.prototype.entries ( )
        CreateMethodProperty(Map.prototype, 'entries', function entries () {
                // 1. Let M be the this value.
                var M = this;
                // 2. Return ? CreateMapIterator(M, "key+value").
                return CreateMapIterator(M, 'key+value');
            }
        );
    
        // 23.1.3.5. Map.prototype.forEach ( callbackfn [ , thisArg ] )
        CreateMethodProperty(Map.prototype, 'forEach', function (callbackFn) {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (Type(M) !== 'object') {
                    throw new TypeError('Method Map.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
                if (!IsCallable(callbackFn)) {
                    throw new TypeError(Object.prototype.toString.call(callbackFn) + ' is not a function.');
                }
                // 5. If thisArg is present, let T be thisArg; else let T be undefined.
                if (arguments[1]) {
                    var T = arguments[1];
                }
                // 6. Let entries be the List that is M.[[MapData]].
                var entries = M._keys;
                // 7. For each Record {[[Key]], [[Value]]} e that is an element of entries, in original key insertion order, do
                for (var i = 0; i < entries.length; i++) {
                    // a. If e.[[Key]] is not empty, then
                    if (M._keys[i] !== undefMarker && M._values[i] !== undefMarker ) {
                        // i. Perform ? Call(callbackfn, T, « e.[[Value]], e.[[Key]], M »).
                        callbackFn.call(T, M._values[i], M._keys[i], M);
                    }
                }
                // 8. Return undefined.
                return undefined;
            }
        );
    
        // 23.1.3.6. Map.prototype.get ( key )
        CreateMethodProperty(Map.prototype, 'get', function get(key) {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (Type(M) !== 'object') {
                    throw new TypeError('Method Map.prototype.get called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.get called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. Let entries be the List that is M.[[MapData]].
                // 5. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                    // a. If p.[[Key]] is not empty and SameValueZero(p.[[Key]], key) is true, return p.[[Value]].
                // 6. Return undefined.
    
                // Implement steps 4-6 with a more optimal algo
                var recordIndex = getRecordIndex(M, key); // O(1) access to record index
                if (recordIndex !== false) {
                    var recordKey = M._keys[recordIndex];
                    if (recordKey !== undefMarker && SameValueZero(recordKey, key)) {
                        return M._values[recordIndex];
                    }
                }
    
                return undefined;
            });
    
        // 23.1.3.7. Map.prototype.has ( key )
        CreateMethodProperty(Map.prototype, 'has', function has (key) {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (typeof M !== 'object') {
                    throw new TypeError('Method Map.prototype.has called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.has called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. Let entries be the List that is M.[[MapData]].
                // 5. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                    // a. If p.[[Key]] is not empty and SameValueZero(p.[[Key]], key) is true, return true.
                // 6. Return false.
    
                // Implement steps 4-6 with a more optimal algo
                var recordIndex = getRecordIndex(M, key); // O(1) access to record index
                if (recordIndex !== false) {
                    var recordKey = M._keys[recordIndex];
                    if (recordKey !== undefMarker && SameValueZero(recordKey, key)) {
                        return true;
                    }
                }
    
                return false;
            });
    
        // 23.1.3.8. Map.prototype.keys ( )
        CreateMethodProperty(Map.prototype, 'keys', function keys () {
                // 1. Let M be the this value.
                var M = this;
                // 2. Return ? CreateMapIterator(M, "key").
                return CreateMapIterator(M, "key");
            });
    
        // 23.1.3.9. Map.prototype.set ( key, value )
        CreateMethodProperty(Map.prototype, 'set', function set(key, value) {
                // 1. Let M be the this value.
                var M = this;
                // 2. If Type(M) is not Object, throw a TypeError exception.
                if (Type(M) !== 'object') {
                    throw new TypeError('Method Map.prototype.set called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                if (M._es6Map !== true) {
                    throw new TypeError('Method Map.prototype.set called on incompatible receiver ' + Object.prototype.toString.call(M));
                }
                // 4. Let entries be the List that is M.[[MapData]].
                // 5. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                // 6. If key is -0, let key be +0.
                // 7. Let p be the Record {[[Key]]: key, [[Value]]: value}.
                // 8. Append p as the last element of entries.
                // 9. Return M.
    
                // Strictly following the above steps 4-9 will lead to an inefficient algorithm.
                // Step 8 also doesn't seem to be required if an entry already exists
                var recordIndex = getRecordIndex(M, key); // O(1) access to record index
                if (recordIndex !== false) {
                    // update path
                    M._values[recordIndex] = value;
                } else {
                    // eslint-disable-next-line no-compare-neg-zero
                    if (key === -0) {
                        key = 0;
                    }
                    var p = {
                        '[[Key]]': key,
                        '[[Value]]': value
                    };
                    M._keys.push(p['[[Key]]']);
                    M._values.push(p['[[Value]]']);
                    setHashIndex(M, key, M._keys.length - 1); // update lookup table
                    ++M._size;
                    if (!supportsGetters) {
                        M.size = M._size;
                    }
                }
                return M;
            });
    
        // 23.1.3.10. get Map.prototype.size
        if (supportsGetters) {
            Object.defineProperty(Map.prototype, 'size', {
                configurable: true,
                enumerable: false,
                get: function () {
                    // 1. Let M be the this value.
                    var M = this;
                    // 2. If Type(M) is not Object, throw a TypeError exception.
                    if (Type(M) !== 'object') {
                        throw new TypeError('Method Map.prototype.size called on incompatible receiver ' + Object.prototype.toString.call(M));
                    }
                    // 3. If M does not have a [[MapData]] internal slot, throw a TypeError exception.
                    if (M._es6Map !== true) {
                        throw new TypeError('Method Map.prototype.size called on incompatible receiver ' + Object.prototype.toString.call(M));
                    }
                    // 4. Let entries be the List that is M.[[MapData]].
                    // 5. Let count be 0.
                    // 6. For each Record {[[Key]], [[Value]]} p that is an element of entries, do
                        // 6a. If p.[[Key]] is not empty, set count to count+1.
                    // 7. Return count.
    
                    // Implement 4-7 more efficently by returning pre-computed property
                    return this._size;
                },
                set: undefined
            });
        }
    
        // 23.1.3.11. Map.prototype.values ( )
        CreateMethodProperty(Map.prototype, 'values', function values () {
                // 1. Let M be the this value.
                var M = this;
                // 2. Return ? CreateMapIterator(M, "value").
                return CreateMapIterator(M, 'value');
            }
        );
    
        // 23.1.3.12. Map.prototype [ @@iterator ] ( )
        // The initial value of the @@iterator property is the same function object as the initial value of the entries property.
        CreateMethodProperty(Map.prototype, Symbol.iterator, Map.prototype.entries);
    
        // 23.1.3.13. Map.prototype [ @@toStringTag ]
        // The initial value of the @@toStringTag property is the String value "Map".
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: true }.
    
        // Polyfill.io - Safari 8 implements Map.name but as a non-configurable property, which means it would throw an error if we try and configure it here.
        if (!('name' in Map)) {
            // 19.2.4.2 name
            Object.defineProperty(Map, 'name', {
                configurable: true,
                enumerable: false,
                writable: false,
                value: 'Map'
            });
        }
    
        // 23.1.5.1. CreateMapIterator ( map, kind )
        function CreateMapIterator(map, kind) {
            // 1. If Type(map) is not Object, throw a TypeError exception.
            if (Type(map) !== 'object') {
                throw new TypeError('createMapIterator called on incompatible receiver ' + Object.prototype.toString.call(map));
            }
            // 2. If map does not have a [[MapData]] internal slot, throw a TypeError exception.
            if (map._es6Map !== true) {
                throw new TypeError('createMapIterator called on incompatible receiver ' + Object.prototype.toString.call(map));
            }
            // 3. Let iterator be ObjectCreate(%MapIteratorPrototype%, « [[Map]], [[MapNextIndex]], [[MapIterationKind]] »).
            var iterator = Object.create(MapIteratorPrototype);
            // 4. Set iterator.[[Map]] to map.
            Object.defineProperty(iterator, '[[Map]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: map
            });
            // 5. Set iterator.[[MapNextIndex]] to 0.
            Object.defineProperty(iterator, '[[MapNextIndex]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: 0
            });
            // 6. Set iterator.[[MapIterationKind]] to kind.
            Object.defineProperty(iterator, '[[MapIterationKind]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: kind
            });
            // 7. Return iterator.
            return iterator;
        }
    
        // 23.1.5.2. The %MapIteratorPrototype% Object
        var MapIteratorPrototype = {};
        // Polyfill.io - We use this as a quick way to check if an object is a Map Iterator instance.
        Object.defineProperty(MapIteratorPrototype, 'isMapIterator', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: true
        });
    
        // 23.1.5.2.1. %MapIteratorPrototype%.next ( )
        CreateMethodProperty(MapIteratorPrototype, 'next', function next() {
                // 1. Let O be the this value.
                var O = this;
                // 2. If Type(O) is not Object, throw a TypeError exception.
                if (Type(O) !== 'object') {
                    throw new TypeError('Method %MapIteratorPrototype%.next called on incompatible receiver ' + Object.prototype.toString.call(O));
                }
                // 3. If O does not have all of the internal slots of a Map Iterator Instance (23.1.5.3), throw a TypeError exception.
                if (!O.isMapIterator) {
                    throw new TypeError('Method %MapIteratorPrototype%.next called on incompatible receiver ' + Object.prototype.toString.call(O));
                }
                // 4. Let m be O.[[Map]].
                var m = O['[[Map]]'];
                // 5. Let index be O.[[MapNextIndex]].
                var index = O['[[MapNextIndex]]'];
                // 6. Let itemKind be O.[[MapIterationKind]].
                var itemKind = O['[[MapIterationKind]]'];
                // 7. If m is undefined, return CreateIterResultObject(undefined, true).
                if (m === undefined) {
                    return CreateIterResultObject(undefined, true);
                }
                // 8. Assert: m has a [[MapData]] internal slot.
                if (!m._es6Map) {
                    throw new Error(Object.prototype.toString.call(m) + ' has a [[MapData]] internal slot.');
                }
                // 9. Let entries be the List that is m.[[MapData]].
                var entries = m._keys;
                // 10. Let numEntries be the number of elements of entries.
                var numEntries = entries.length;
                // 11. NOTE: numEntries must be redetermined each time this method is evaluated.
                // 12. Repeat, while index is less than numEntries,
                while (index < numEntries) {
                    // a. Let e be the Record {[[Key]], [[Value]]} that is the value of entries[index].
                    var e = Object.create(null);
                    e['[[Key]]'] = m._keys[index];
                    e['[[Value]]'] = m._values[index];
                    // b. Set index to index+1.
                    index = index + 1;
                    // c. Set O.[[MapNextIndex]] to index.
                    O['[[MapNextIndex]]'] = index;
                    // d. If e.[[Key]] is not empty, then
                    if (e['[[Key]]'] !== undefMarker) {
                        // i. If itemKind is "key", let result be e.[[Key]].
                        if (itemKind === 'key') {
                            var result = e['[[Key]]'];
                            // ii. Else if itemKind is "value", let result be e.[[Value]].
                        } else if (itemKind === 'value') {
                            result = e['[[Value]]'];
                            // iii. Else,
                        } else {
                            // 1. Assert: itemKind is "key+value".
                            if (itemKind !== 'key+value') {
                                throw new Error();
                            }
                            // 2. Let result be CreateArrayFromList(« e.[[Key]], e.[[Value]] »).
                            result = [
                                e['[[Key]]'],
                                e['[[Value]]']
                            ];
                        }
                        // iv. Return CreateIterResultObject(result, false).
                        return CreateIterResultObject(result, false);
                    }
                }
                // 13. Set O.[[Map]] to undefined.
                O['[[Map]]'] = undefined;
                // 14. Return CreateIterResultObject(undefined, true).
                return CreateIterResultObject(undefined, true);
            }
        );
    
        // 23.1.5.2.2 %MapIteratorPrototype% [ @@toStringTag ]
        // The initial value of the @@toStringTag property is the String value "Map Iterator".
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: true }.
    
        CreateMethodProperty(MapIteratorPrototype, Symbol.iterator, function iterator() {
                return this;
            }
        );
    
        // Export the object
        try {
            CreateMethodProperty(global, 'Map', Map);
        } catch (e) {
            // IE8 throws an error here if we set enumerable to false.
            // More info on table 2: https://msdn.microsoft.com/en-us/library/dd229916(v=vs.85).aspx
            global.Map = Map;
        }
    }(self));
    
    // Set
    /* global CreateIterResultObject, CreateMethodProperty, GetIterator, IsCallable, IteratorClose, IteratorStep, IteratorValue, OrdinaryCreateFromConstructor, SameValueZero, Symbol */
    (function (global) {
        var supportsGetters = (function () {
            try {
                var a = {};
                Object.defineProperty(a, 't', {
                    configurable: true,
                    enumerable: false,
                    get: function () {
                        return true;
                    },
                    set: undefined
                });
                return !!a.t;
            } catch (e) {
                return false;
            }
        }());
    
        // Deleted set items mess with iterator pointers, so rather than removing them mark them as deleted. Can't use undefined or null since those both valid keys so use a private symbol.
        var undefMarker = Symbol('undef');
        // 23.2.1.1. Set ( [ iterable ] )
        var Set = function Set(/* iterable */) {
            // 1. If NewTarget is undefined, throw a TypeError exception.
            if (!(this instanceof Set)) {
                throw new TypeError('Constructor Set requires "new"');
            }
            // 2. Let set be ? OrdinaryCreateFromConstructor(NewTarget, "%SetPrototype%", « [[SetData]] »).
            var set = OrdinaryCreateFromConstructor(this, Set.prototype, {
                _values: [],
                _size: 0,
                _es6Set: true
            });
    
            // 3. Set set.[[SetData]] to a new empty List.
            // Polyfill.io - This step was done as part of step two.
    
            // Some old engines do not support ES5 getters/setters.  Since Set only requires these for the size property, we can fall back to setting the size property statically each time the size of the set changes.
            if (!supportsGetters) {
                Object.defineProperty(set, 'size', {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: 0
                });
            }
    
            // 4. If iterable is not present, let iterable be undefined.
            var iterable = arguments.length > 0 ? arguments[0] : undefined;
    
            // 5. If iterable is either undefined or null, return set.
            if (iterable === null || iterable === undefined) {
                return set;
            }
    
            // 6. Let adder be ? Get(set, "add").
            var adder = set.add;
            // 7. If IsCallable(adder) is false, throw a TypeError exception.
            if (!IsCallable(adder)) {
                throw new TypeError("Set.prototype.add is not a function");
            }
    
            try {
                // 8. Let iteratorRecord be ? GetIterator(iterable).
                var iteratorRecord = GetIterator(iterable);
                // 9. Repeat,
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    // a. Let next be ? IteratorStep(iteratorRecord).
                    var next = IteratorStep(iteratorRecord);
                    // b. If next is false, return set.
                    if (next === false) {
                        return set;
                    }
                    // c. Let nextValue be ? IteratorValue(next).
                    var nextValue = IteratorValue(next);
                    // d. Let status be Call(adder, set, « nextValue.[[Value]] »).
                    try {
                        adder.call(set, nextValue);
                    } catch (e) {
                        // e. If status is an abrupt completion, return ? IteratorClose(iteratorRecord, status).
                        return IteratorClose(iteratorRecord, e);
                    }
                }
            } catch (e) {
                // Polyfill.io - For user agents which do not have iteration methods on argument objects or arrays, we can special case those.
                if (Array.isArray(iterable) ||
                    Object.prototype.toString.call(iterable) === '[object Arguments]' ||
                    // IE 7 & IE 8 return '[object Object]' for the arguments object, we can detect by checking for the existence of the callee property
                    (!!iterable.callee)) {
                    var index;
                    var length = iterable.length;
                    for (index = 0; index < length; index++) {
                        adder.call(set, iterable[index]);
                    }
                } else {
                    throw (e);
                }
            }
            return set;
        };
    
        // 23.2.2.1. Set.prototype
        // The initial value of Set.prototype is the intrinsic %SetPrototype% object.
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: false }.
        Object.defineProperty(Set, 'prototype', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: {}
        });
    
        // 23.2.2.2 get Set [ @@species ]
        if (supportsGetters) {
            Object.defineProperty(Set, Symbol.species, {
                configurable: true,
                enumerable: false,
                get: function () {
                    // 1. Return the this value.
                    return this;
                },
                set: undefined
            });
        } else {
            CreateMethodProperty(Set, Symbol.species, Set);
        }
    
        // 23.2.3.1. Set.prototype.add ( value )
        CreateMethodProperty(Set.prototype, 'add', function add(value) {
                // 1. Let S be the this value.
                var S = this;
                // 2. If Type(S) is not Object, throw a TypeError exception.
                if (typeof S !== 'object') {
                    throw new TypeError('Method Set.prototype.add called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                if (S._es6Set !== true) {
                    throw new TypeError('Method Set.prototype.add called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 4. Let entries be the List that is S.[[SetData]].
                var entries = S._values;
                // 5. For each e that is an element of entries, do
                for (var i = 0; i < entries.length; i++) {
                    var e = entries[i];
                    // a. If e is not empty and SameValueZero(e, value) is true, then
                    if (e !== undefMarker && SameValueZero(e, value)) {
                        // i. Return S.
                        return S;
                    }
                }
                // 6. If value is -0, let value be +0.
                if (value === 0 && 1/value === -Infinity) {
                    value = 0;
                }
                // 7. Append value as the last element of entries.
                S._values.push(value);
    
                this._size = ++this._size;
                if (!supportsGetters) {
                    this.size = this._size;
                }
                // 8. Return S.
                return S;
            });
    
        // 23.2.3.2. Set.prototype.clear ( )
        CreateMethodProperty(Set.prototype, 'clear', function clear() {
                // 1. Let S be the this value.
                var S = this;
                // 2. If Type(S) is not Object, throw a TypeError exception.
                if (typeof S !== 'object') {
                    throw new TypeError('Method Set.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                if (S._es6Set !== true) {
                    throw new TypeError('Method Set.prototype.clear called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 4. Let entries be the List that is S.[[SetData]].
                var entries = S._values;
                // 5. For each e that is an element of entries, do
                for (var i = 0; i < entries.length; i++) {
                    // a. Replace the element of entries whose value is e with an element whose value is empty.
                    entries[i] = undefMarker;
                }
                this._size = 0;
                if (!supportsGetters) {
                    this.size = this._size;
                }
                // 6. Return undefined.
                return undefined;
            });
    
        // 23.2.3.3. Set.prototype.constructor
        CreateMethodProperty(Set.prototype, 'constructor', Set);
    
        // 23.2.3.4. Set.prototype.delete ( value )
        CreateMethodProperty(Set.prototype, 'delete', function (value) {
                // 1. Let S be the this value.
                var S = this;
                // 2. If Type(S) is not Object, throw a TypeError exception.
                if (typeof S !== 'object') {
                    throw new TypeError('Method Set.prototype.delete called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                if (S._es6Set !== true) {
                    throw new TypeError('Method Set.prototype.delete called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 4. Let entries be the List that is S.[[SetData]].
                var entries = S._values;
                // 5. For each e that is an element of entries, do
                for (var i = 0; i < entries.length; i++) {
                    var e = entries[i];
                    // a. If e is not empty and SameValueZero(e, value) is true, then
                    if (e !== undefMarker && SameValueZero(e, value)) {
                        // i. Replace the element of entries whose value is e with an element whose value is empty.
                        entries[i] = undefMarker;
    
                        this._size = --this._size;
                        if (!supportsGetters) {
                            this.size = this._size;
                        }
                        // ii. Return true.
                        return true;
                    }
                }
                // 6. Return false.
                return false;
            }
        );
    
        // 23.2.3.5. Set.prototype.entries ( )
        CreateMethodProperty(Set.prototype, 'entries', function entries() {
                // 1. Let S be the this value.
                var S = this;
                // 2. Return ? CreateSetIterator(S, "key+value").
                return CreateSetIterator(S, 'key+value');
            }
        );
    
        // 23.2.3.6. Set.prototype.forEach ( callbackfn [ , thisArg ] )
        CreateMethodProperty(Set.prototype, 'forEach', function forEach(callbackFn /*[ , thisArg ]*/) {
                // 1. Let S be the this value.
                var S = this;
                // 2. If Type(S) is not Object, throw a TypeError exception.
                if (typeof S !== 'object') {
                    throw new TypeError('Method Set.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                if (S._es6Set !== true) {
                    throw new TypeError('Method Set.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
                if (!IsCallable(callbackFn)) {
                    throw new TypeError(Object.prototype.toString.call(callbackFn) + ' is not a function.');
                }
                // 5. If thisArg is present, let T be thisArg; else let T be undefined.
                if (arguments[1]) {
                    var T = arguments[1];
                }
                // 6. Let entries be the List that is S.[[SetData]].
                var entries = S._values;
                // 7. For each e that is an element of entries, in original insertion order, do
                for (var i = 0; i < entries.length; i++) {
                    var e = entries[i];
                    // a. If e is not empty, then
                    if (e !== undefMarker) {
                        // i. Perform ? Call(callbackfn, T, « e, e, S »).
                        callbackFn.call(T, e, e, S);
                    }
                }
                // 8. Return undefined.
                return undefined;
            }
        );
    
        // 23.2.3.7. Set.prototype.has ( value )
        CreateMethodProperty(Set.prototype, 'has', function has(value) {
                // 1. Let S be the this value.
                var S = this;
                // 2. If Type(S) is not Object, throw a TypeError exception.
                if (typeof S !== 'object') {
                    throw new TypeError('Method Set.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                if (S._es6Set !== true) {
                    throw new TypeError('Method Set.prototype.forEach called on incompatible receiver ' + Object.prototype.toString.call(S));
                }
                // 4. Let entries be the List that is S.[[SetData]].
                var entries = S._values;
                // 5. For each e that is an element of entries, do
                for (var i = 0; i < entries.length; i++) {
                    var e = entries[i];
                    // a. If e is not empty and SameValueZero(e, value) is true, return true.
                    if (e !== undefMarker && SameValueZero(e, value)) {
                        return true;
                    }
                }
                // 6. Return false.
                return false;
            }
        );
    
        // Polyfill.io - We need to define Set.prototype.values before Set.prototype.keys because keys is a reference to values.
        // 23.2.3.10. Set.prototype.values()
        var values = function values() {
            // 1. Let S be the this value.
            var S = this;
            // 2. Return ? CreateSetIterator(S, "value").
            return CreateSetIterator(S, "value");
        };
        CreateMethodProperty(Set.prototype, 'values', values);
    
        // 23.2.3.8 Set.prototype.keys ( )
        // The initial value of the keys property is the same function object as the initial value of the values property.
        CreateMethodProperty(Set.prototype, 'keys', values);
    
        // 23.2.3.9. get Set.prototype.size
        if (supportsGetters) {
            Object.defineProperty(Set.prototype, 'size', {
                configurable: true,
                enumerable: false,
                get: function () {
                    // 1. Let S be the this value.
                    var S = this;
                    // 2. If Type(S) is not Object, throw a TypeError exception.
                    if (typeof S !== 'object') {
                        throw new TypeError('Method Set.prototype.size called on incompatible receiver ' + Object.prototype.toString.call(S));
                    }
                    // 3. If S does not have a [[SetData]] internal slot, throw a TypeError exception.
                    if (S._es6Set !== true) {
                        throw new TypeError('Method Set.prototype.size called on incompatible receiver ' + Object.prototype.toString.call(S));
                    }
                    // 4. Let entries be the List that is S.[[SetData]].
                    var entries = S._values;
                    // 5. Let count be 0.
                    var count = 0;
                    // 6. For each e that is an element of entries, do
                    for (var i = 0; i < entries.length; i++) {
                        var e = entries[i];
                        // a. If e is not empty, set count to count+1.
                        if (e !== undefMarker) {
                            count = count + 1;
                        }
                    }
                    // 7. Return count.
                    return count;
                },
                set: undefined
            });
        }
    
        // 23.2.3.11. Set.prototype [ @@iterator ] ( )
        // The initial value of the @@iterator property is the same function object as the initial value of the values property.
        CreateMethodProperty(Set.prototype, Symbol.iterator, values);
    
        // 23.2.3.12. Set.prototype [ @@toStringTag ]
        // The initial value of the @@toStringTag property is the String value "Set".
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: true }.
    
        // Polyfill.io - Safari 8 implements Set.name but as a non-configurable property, which means it would throw an error if we try and configure it here.
        if (!('name' in Set)) {
            // 19.2.4.2 name
            Object.defineProperty(Set, 'name', {
                configurable: true,
                enumerable: false,
                writable: false,
                value: 'Set'
            });
        }
    
        // 23.2.5.1. CreateSetIterator ( set, kind )
        function CreateSetIterator(set, kind) {
            // 1. If Type(set) is not Object, throw a TypeError exception.
            if (typeof set !== 'object') {
                throw new TypeError('createSetIterator called on incompatible receiver ' + Object.prototype.toString.call(set));
            }
            // 2. If set does not have a [[SetData]] internal slot, throw a TypeError exception.
            if (set._es6Set !== true) {
                throw new TypeError('createSetIterator called on incompatible receiver ' + Object.prototype.toString.call(set));
            }
            // 3. Let iterator be ObjectCreate(%SetIteratorPrototype%, « [[IteratedSet]], [[SetNextIndex]], [[SetIterationKind]] »).
            var iterator = Object.create(SetIteratorPrototype);
            // 4. Set iterator.[[IteratedSet]] to set.
            Object.defineProperty(iterator, '[[IteratedSet]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: set
            });
            // 5. Set iterator.[[SetNextIndex]] to 0.
            Object.defineProperty(iterator, '[[SetNextIndex]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: 0
            });
            // 6. Set iterator.[[SetIterationKind]] to kind.
            Object.defineProperty(iterator, '[[SetIterationKind]]', {
                configurable: true,
                enumerable: false,
                writable: true,
                value: kind
            });
            // 7. Return iterator.
            return iterator;
        }
    
        // 23.2.5.2. The %SetIteratorPrototype% Object
        var SetIteratorPrototype = {};
        //Polyfill.io - We add this property to help us identify what is a set iterator.
        Object.defineProperty(SetIteratorPrototype, 'isSetIterator', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: true
        });
    
        // 23.2.5.2.1. %SetIteratorPrototype%.next ( )
        CreateMethodProperty(SetIteratorPrototype, 'next', function next() {
            // 1. Let O be the this value.
            var O = this;
            // 2. If Type(O) is not Object, throw a TypeError exception.
            if (typeof O !== 'object') {
                throw new TypeError('Method %SetIteratorPrototype%.next called on incompatible receiver ' + Object.prototype.toString.call(O));
            }
            // 3. If O does not have all of the internal slots of a Set Iterator Instance (23.2.5.3), throw a TypeError exception.
            if (!O.isSetIterator) {
                throw new TypeError('Method %SetIteratorPrototype%.next called on incompatible receiver ' + Object.prototype.toString.call(O));
            }
            // 4. Let s be O.[[IteratedSet]].
            var s = O['[[IteratedSet]]'];
            // 5. Let index be O.[[SetNextIndex]].
            var index = O['[[SetNextIndex]]'];
            // 6. Let itemKind be O.[[SetIterationKind]].
            var itemKind = O['[[SetIterationKind]]'];
            // 7. If s is undefined, return CreateIterResultObject(undefined, true).
            if (s === undefined) {
                return CreateIterResultObject(undefined, true);
            }
            // 8. Assert: s has a [[SetData]] internal slot.
            if (!s._es6Set) {
                throw new Error(Object.prototype.toString.call(s) + ' does not have [[SetData]] internal slot.');
            }
            // 9. Let entries be the List that is s.[[SetData]].
            var entries = s._values;
            // 10. Let numEntries be the number of elements of entries.
            var numEntries = entries.length;
            // 11. NOTE: numEntries must be redetermined each time this method is evaluated.
            // 12. Repeat, while index is less than numEntries,
            while (index < numEntries) {
                // a. Let e be entries[index].
                var e = entries[index];
                // b. Set index to index+1.
                index = index + 1;
                // c. Set O.[[SetNextIndex]] to index.
                O['[[SetNextIndex]]'] = index;
                // d. If e is not empty, then
                if (e !== undefMarker) {
                    // i. If itemKind is "key+value", then
                    if (itemKind === 'key+value') {
                        // 1. Return CreateIterResultObject(CreateArrayFromList(« e, e »), false).
                        return CreateIterResultObject([e, e], false);
                    }
                    // ii. Return CreateIterResultObject(e, false).
                    return CreateIterResultObject(e, false);
                }
            }
            // 13. Set O.[[IteratedSet]] to undefined.
            O['[[IteratedSet]]'] = undefined;
            // 14. Return CreateIterResultObject(undefined, true).
            return CreateIterResultObject(undefined, true);
        });
    
        // 23.2.5.2.2. %SetIteratorPrototype% [ @@toStringTag ]
        // The initial value of the @@toStringTag property is the String value "Set Iterator".
        // This property has the attributes { [[Writable]]: false, [[Enumerable]]: false, [[Configurable]]: true }.
    
        CreateMethodProperty(SetIteratorPrototype, Symbol.iterator, function iterator() {
                return this;
            }
        );
    
        // Export the object
        try {
            CreateMethodProperty(global, 'Set', Set);
        } catch (e) {
            // IE8 throws an error here if we set enumerable to false.
            // More info on table 2: https://msdn.microsoft.com/en-us/library/dd229916(v=vs.85).aspx
            global.Set = Set;
        }
    
    }(self));
    
    // Array.from
    /* globals
        IsCallable, GetMethod, Symbol, IsConstructor, Construct, ArrayCreate, GetIterator, IteratorClose,
        ToString, IteratorStep, IteratorValue, Call, CreateDataPropertyOrThrow, ToObject, ToLength, Get, CreateMethodProperty
    */
    (function () {
        var toString = Object.prototype.toString;
        var stringMatch = String.prototype.match;
        // A cross-realm friendly way to detect if a value is a String object or literal.
        function isString(value) {
            if (typeof value === 'string') { return true; }
            if (typeof value !== 'object') { return false; }
            return toString.call(value) === '[object String]';
        }
    
        // 22.1.2.1. Array.from ( items [ , mapfn [ , thisArg ] ] )
        CreateMethodProperty(Array, 'from', function from(items /* [ , mapfn [ , thisArg ] ] */) { // eslint-disable-line no-undef
            // 1. Let C be the this value.
            var C = this;
            // 2. If mapfn is undefined, let mapping be false.
            var mapfn = arguments.length > 1 ? arguments[1] : undefined;
            if (mapfn === undefined) {
                var mapping = false;
                // 3. Else,
            } else {
                // a. If IsCallable(mapfn) is false, throw a TypeError exception.
                if (IsCallable(mapfn) === false) {
                    throw new TypeError(Object.prototype.toString.call(mapfn) + ' is not a function.');
                }
                // b. If thisArg is present, let T be thisArg; else let T be undefined.
                var thisArg = arguments.length > 2 ? arguments[2] : undefined;
                if (thisArg !== undefined) {
                    var T = thisArg;
                } else {
                    T = undefined;
                }
                // c. Let mapping be true.
                mapping = true;
    
            }
            // 4. Let usingIterator be ? GetMethod(items, @@iterator).
            var usingIterator = GetMethod(items, Symbol.iterator);
            // 5. If usingIterator is not undefined, then
            if (usingIterator !== undefined) {
                // a. If IsConstructor(C) is true, then
                if (IsConstructor(C)) {
                    // i. Let A be ? Construct(C).
                    var A = Construct(C);
                    // b. Else,
                } else {
                    // i. Let A be ! ArrayCreate(0).
                    A = ArrayCreate(0);
                }
                // c. Let iteratorRecord be ? GetIterator(items, usingIterator).
                var iteratorRecord = GetIterator(items, usingIterator);
                // d. Let k be 0.
                var k = 0;
                // e. Repeat,
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    // i. If k ≥ 2^53-1, then
                    if (k >= (Math.pow(2, 53) - 1)) {
                        // 1. Let error be Completion{[[Type]]: throw, [[Value]]: a newly created TypeError object, [[Target]]: empty}.
                        var error = new TypeError('Iteration count can not be greater than or equal 9007199254740991.');
                        // 2. Return ? IteratorClose(iteratorRecord, error).
                        return IteratorClose(iteratorRecord, error);
                    }
                    // ii. Let Pk be ! ToString(k).
                    var Pk = ToString(k);
                    // iii. Let next be ? IteratorStep(iteratorRecord).
                    var next = IteratorStep(iteratorRecord);
                    // iv. If next is false, then
                    if (next === false) {
                        // 1. Perform ? Set(A, "length", k, true).
                        A.length = k;
                        // 2. Return A.
                        return A;
                    }
                    // v. Let nextValue be ? IteratorValue(next).
                    var nextValue = IteratorValue(next);
                    // vi. If mapping is true, then
                    if (mapping) {
                        try {
                            // Polyfill.io - The try catch accounts for step 2.
                            // 1. Let mappedValue be Call(mapfn, T, « nextValue, k »).
                            var mappedValue = Call(mapfn, T, [nextValue, k]);
                            // 2. If mappedValue is an abrupt completion, return ? IteratorClose(iteratorRecord, mappedValue).
                            // 3. Let mappedValue be mappedValue.[[Value]].
                        } catch (e) {
                            return IteratorClose(iteratorRecord, e);
                        }
    
                        // vii. Else, let mappedValue be nextValue.
                    } else {
                        mappedValue = nextValue;
                    }
                    try {
                        // Polyfill.io - The try catch accounts for step ix.
                        // viii. Let defineStatus be CreateDataPropertyOrThrow(A, Pk, mappedValue).
                        CreateDataPropertyOrThrow(A, Pk, mappedValue);
                        // ix. If defineStatus is an abrupt completion, return ? IteratorClose(iteratorRecord, defineStatus).
                    } catch (e) {
                        return IteratorClose(iteratorRecord, e);
                    }
                    // x. Increase k by 1.
                    k = k + 1;
                }
            }
            // 6. NOTE: items is not an Iterable so assume it is an array-like object.
            // 7. Let arrayLike be ! ToObject(items).
            // Polyfill.io - For Strings we need to split astral symbols into surrogate pairs.
            if (isString(items)) {
                var arrayLike = stringMatch.call(items, /[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
            } else {
                arrayLike = ToObject(items);
            }
            // 8. Let len be ? ToLength(? Get(arrayLike, "length")).
            var len = ToLength(Get(arrayLike, "length"));
            // 9. If IsConstructor(C) is true, then
            if (IsConstructor(C)) {
                // a. Let A be ? Construct(C, « len »).
                A = Construct(C, [len]);
                // 10. Else,
            } else {
                // a. Let A be ? ArrayCreate(len).
                A = ArrayCreate(len);
            }
            // 11. Let k be 0.
            k = 0;
            // 12. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                Pk = ToString(k);
                // b. Let kValue be ? Get(arrayLike, Pk).
                var kValue = Get(arrayLike, Pk);
                // c. If mapping is true, then
                if (mapping === true) {
                    // i. Let mappedValue be ? Call(mapfn, T, « kValue, k »).
                    mappedValue = Call(mapfn, T, [kValue, k]);
                    // d. Else, let mappedValue be kValue.
                } else {
                    mappedValue = kValue;
                }
                // e. Perform ? CreateDataPropertyOrThrow(A, Pk, mappedValue).
                CreateDataPropertyOrThrow(A, Pk, mappedValue);
                // f. Increase k by 1.
                k = k + 1;
            }
            // 13. Perform ? Set(A, "length", len, true).
            A.length = len;
            // 14. Return A.
            return A;
        });
    }());
    
    // URL
    /* global Symbol */
    // URL Polyfill
    // Draft specification: https://url.spec.whatwg.org
    
    // Notes:
    // - Primarily useful for parsing URLs and modifying query parameters
    // - Should work in IE8+ and everything more modern, with es5.js polyfills
    
    (function (global) {
        'use strict';
    
        function isSequence(o) {
            if (!o) return false;
            if ('Symbol' in global && 'iterator' in global.Symbol &&
                    typeof o[Symbol.iterator] === 'function') return true;
            if (Array.isArray(o)) return true;
            return false;
        }
    
        ;(function() { // eslint-disable-line no-extra-semi
    
            // Browsers may have:
            // * No global URL object
            // * URL with static methods only - may have a dummy constructor
            // * URL with members except searchParams
            // * Full URL API support
            var origURL = global.URL;
            var nativeURL;
            try {
                if (origURL) {
                    nativeURL = new global.URL('http://example.com');
                    if ('searchParams' in nativeURL) {
                        var url = new URL('http://example.com');
                        url.search = 'a=1&b=2';
                        if (url.href === 'http://example.com/?a=1&b=2') {
                            url.search = '';
                            if (url.href === 'http://example.com/') {
                                return;
                            }
                        }
                    }
                    if (!('href' in nativeURL)) {
                        nativeURL = undefined;
                    }
                    nativeURL = undefined;
                }
            // eslint-disable-next-line no-empty
            } catch (_) {}
    
            // NOTE: Doesn't do the encoding/decoding dance
            function urlencoded_serialize(pairs) {
                var output = '', first = true;
                pairs.forEach(function (pair) {
                    var name = encodeURIComponent(pair.name);
                    var value = encodeURIComponent(pair.value);
                    if (!first) output += '&';
                    output += name + '=' + value;
                    first = false;
                });
                return output.replace(/%20/g, '+');
            }
    
            // NOTE: Doesn't do the encoding/decoding dance
            function urlencoded_parse(input, isindex) {
                var sequences = input.split('&');
                if (isindex && sequences[0].indexOf('=') === -1)
                    sequences[0] = '=' + sequences[0];
                var pairs = [];
                sequences.forEach(function (bytes) {
                    if (bytes.length === 0) return;
                    var index = bytes.indexOf('=');
                    if (index !== -1) {
                        var name = bytes.substring(0, index);
                        var value = bytes.substring(index + 1);
                    } else {
                        name = bytes;
                        value = '';
                    }
                    name = name.replace(/\+/g, ' ');
                    value = value.replace(/\+/g, ' ');
                    pairs.push({ name: name, value: value });
                });
                var output = [];
                pairs.forEach(function (pair) {
                    output.push({
                        name: decodeURIComponent(pair.name),
                        value: decodeURIComponent(pair.value)
                    });
                });
                return output;
            }
    
            function URLUtils(url) {
                if (nativeURL)
                    return new origURL(url);
                var anchor = document.createElement('a');
                anchor.href = url;
                return anchor;
            }
    
            function URLSearchParams(init) {
                var $this = this;
                this._list = [];
    
                if (init === undefined || init === null) {
                    // no-op
                } else if (init instanceof URLSearchParams) {
                    // In ES6 init would be a sequence, but special case for ES5.
                    this._list = urlencoded_parse(String(init));
                } else if (typeof init === 'object' && isSequence(init)) {
                    Array.from(init).forEach(function(e) {
                        if (!isSequence(e)) throw TypeError();
                        var nv = Array.from(e);
                        if (nv.length !== 2) throw TypeError();
                        $this._list.push({name: String(nv[0]), value: String(nv[1])});
                    });
                } else if (typeof init === 'object' && init) {
                    Object.keys(init).forEach(function(key) {
                        $this._list.push({name: String(key), value: String(init[key])});
                    });
                } else {
                    init = String(init);
                    if (init.substring(0, 1) === '?')
                        init = init.substring(1);
                    this._list = urlencoded_parse(init);
                }
    
                this._url_object = null;
                this._setList = function (list) { if (!updating) $this._list = list; };
    
                var updating = false;
                this._update_steps = function() {
                    if (updating) return;
                    updating = true;
    
                    if (!$this._url_object) return;
    
                    // Partial workaround for IE issue with 'about:'
                    if ($this._url_object.protocol === 'about:' &&
                            $this._url_object.pathname.indexOf('?') !== -1) {
                        $this._url_object.pathname = $this._url_object.pathname.split('?')[0];
                    }
    
                    $this._url_object.search = urlencoded_serialize($this._list);
    
                    updating = false;
                };
            }
    
    
            Object.defineProperties(URLSearchParams.prototype, {
                append: {
                    value: function (name, value) {
                        this._list.push({ name: name, value: value });
                        this._update_steps();
                    }, writable: true, enumerable: true, configurable: true
                },
    
                'delete': {
                    value: function (name) {
                        for (var i = 0; i < this._list.length;) {
                            if (this._list[i].name === name)
                                this._list.splice(i, 1);
                            else
                                ++i;
                        }
                        this._update_steps();
                    }, writable: true, enumerable: true, configurable: true
                },
    
                get: {
                    value: function (name) {
                        for (var i = 0; i < this._list.length; ++i) {
                            if (this._list[i].name === name)
                                return this._list[i].value;
                        }
                        return null;
                    }, writable: true, enumerable: true, configurable: true
                },
    
                getAll: {
                    value: function (name) {
                        var result = [];
                        for (var i = 0; i < this._list.length; ++i) {
                            if (this._list[i].name === name)
                                result.push(this._list[i].value);
                        }
                        return result;
                    }, writable: true, enumerable: true, configurable: true
                },
    
                has: {
                    value: function (name) {
                        for (var i = 0; i < this._list.length; ++i) {
                            if (this._list[i].name === name)
                                return true;
                        }
                        return false;
                    }, writable: true, enumerable: true, configurable: true
                },
    
                set: {
                    value: function (name, value) {
                        var found = false;
                        for (var i = 0; i < this._list.length;) {
                            if (this._list[i].name === name) {
                                if (!found) {
                                    this._list[i].value = value;
                                    found = true;
                                    ++i;
                                } else {
                                    this._list.splice(i, 1);
                                }
                            } else {
                                ++i;
                            }
                        }
    
                        if (!found)
                            this._list.push({ name: name, value: value });
    
                        this._update_steps();
                    }, writable: true, enumerable: true, configurable: true
                },
    
                entries: {
                    value: function() { return new Iterator(this._list, 'key+value'); },
                    writable: true, enumerable: true, configurable: true
                },
    
                keys: {
                    value: function() { return new Iterator(this._list, 'key'); },
                    writable: true, enumerable: true, configurable: true
                },
    
                values: {
                    value: function() { return new Iterator(this._list, 'value'); },
                    writable: true, enumerable: true, configurable: true
                },
    
                forEach: {
                    value: function(callback) {
                        var thisArg = (arguments.length > 1) ? arguments[1] : undefined;
                        this._list.forEach(function(pair) {
                            callback.call(thisArg, pair.value, pair.name);
                        });
    
                    }, writable: true, enumerable: true, configurable: true
                },
    
                toString: {
                    value: function () {
                        return urlencoded_serialize(this._list);
                    }, writable: true, enumerable: false, configurable: true
                },
    
                sort: {
                    value: function sort() {
                        var entries = this.entries();
                        var entry = entries.next();
                        var keys = [];
                        var values = {};
    
                        while (!entry.done) {
                            var value = entry.value;
                            var key = value[0];
                            keys.push(key);
                            if (!(Object.prototype.hasOwnProperty.call(values, key))) {
                                values[key] = [];
                            }
                            values[key].push(value[1]);
                            entry = entries.next();
                        }
    
                        keys.sort();
                        for (var i = 0; i < keys.length; i++) {
                            this["delete"](keys[i]);
                        }
                        for (var j = 0; j < keys.length; j++) {
                            key = keys[j];
                            this.append(key, values[key].shift());
                        }
                    }
                }
            });
    
            function Iterator(source, kind) {
                var index = 0;
                this.next = function() {
                    if (index >= source.length)
                        return {done: true, value: undefined};
                    var pair = source[index++];
                    return {done: false, value:
                                    kind === 'key' ? pair.name :
                                    kind === 'value' ? pair.value :
                                    [pair.name, pair.value]};
                };
            }
    
            if ('Symbol' in global && 'iterator' in global.Symbol) {
                Object.defineProperty(URLSearchParams.prototype, global.Symbol.iterator, {
                    value: URLSearchParams.prototype.entries,
                    writable: true, enumerable: true, configurable: true});
                Object.defineProperty(Iterator.prototype, global.Symbol.iterator, {
                    value: function() { return this; },
                    writable: true, enumerable: true, configurable: true});
            }
    
            function URL(url, base) {
                if (!(this instanceof global.URL))
                    throw new TypeError("Failed to construct 'URL': Please use the 'new' operator.");
    
                if (base) {
                    url = (function () {
                        if (nativeURL) return new origURL(url, base).href;
                        var iframe;
                        try {
                            var doc;
                            // Use another document/base tag/anchor for relative URL resolution, if possible
                            if (Object.prototype.toString.call(window.operamini) === "[object OperaMini]") {
                                iframe = document.createElement('iframe');
                                iframe.style.display = 'none';
                                document.documentElement.appendChild(iframe);
                                doc = iframe.contentWindow.document;
                            } else if (document.implementation && document.implementation.createHTMLDocument) {
                                doc = document.implementation.createHTMLDocument('');
                            } else if (document.implementation && document.implementation.createDocument) {
                                doc = document.implementation.createDocument('http://www.w3.org/1999/xhtml', 'html', null);
                                doc.documentElement.appendChild(doc.createElement('head'));
                                doc.documentElement.appendChild(doc.createElement('body'));
                            } else if (window.ActiveXObject) {
                                doc = new window.ActiveXObject('htmlfile');
                                doc.write('<head></head><body></body>');
                                doc.close();
                            }
    
                            if (!doc) throw Error('base not supported');
    
                            var baseTag = doc.createElement('base');
                            baseTag.href = base;
                            doc.getElementsByTagName('head')[0].appendChild(baseTag);
                            var anchor = doc.createElement('a');
                            anchor.href = url;
                            return anchor.href;
                        } finally {
                            if (iframe)
                                iframe.parentNode.removeChild(iframe);
                        }
                    }());
                }
    
                // An inner object implementing URLUtils (either a native URL
                // object or an HTMLAnchorElement instance) is used to perform the
                // URL algorithms. With full ES5 getter/setter support, return a
                // regular object For IE8's limited getter/setter support, a
                // different HTMLAnchorElement is returned with properties
                // overridden
    
                var instance = URLUtils(url || '');
    
                // Detect for ES5 getter/setter support
                // (an Object.defineProperties polyfill that doesn't support getters/setters may throw)
                var ES5_GET_SET = (function() {
                    if (!('defineProperties' in Object)) return false;
                    try {
                        var obj = {};
                        Object.defineProperties(obj, { prop: { get: function () { return true; } } });
                        return obj.prop;
                    } catch (_) {
                        return false;
                    }
                }());
    
                var self = ES5_GET_SET ? this : document.createElement('a');
    
    
    
                var query_object = new URLSearchParams(
                    instance.search ? instance.search.substring(1) : null);
                query_object._url_object = self;
    
                Object.defineProperties(self, {
                    href: {
                        get: function () { return instance.href; },
                        set: function (v) { instance.href = v; tidy_instance(); update_steps(); },
                        enumerable: true, configurable: true
                    },
                    origin: {
                        get: function () {
                            if (this.protocol.toLowerCase() === "data:") {
                                return null
                            }
    
                            if ('origin' in instance) return instance.origin;
                            return this.protocol + '//' + this.host;
                        },
                        enumerable: true, configurable: true
                    },
                    protocol: {
                        get: function () { return instance.protocol; },
                        set: function (v) { instance.protocol = v; },
                        enumerable: true, configurable: true
                    },
                    username: {
                        get: function () { return instance.username; },
                        set: function (v) { instance.username = v; },
                        enumerable: true, configurable: true
                    },
                    password: {
                        get: function () { return instance.password; },
                        set: function (v) { instance.password = v; },
                        enumerable: true, configurable: true
                    },
                    host: {
                        get: function () {
                            // IE returns default port in |host|
                            var re = {'http:': /:80$/, 'https:': /:443$/, 'ftp:': /:21$/}[instance.protocol];
                            return re ? instance.host.replace(re, '') : instance.host;
                        },
                        set: function (v) { instance.host = v; },
                        enumerable: true, configurable: true
                    },
                    hostname: {
                        get: function () { return instance.hostname; },
                        set: function (v) { instance.hostname = v; },
                        enumerable: true, configurable: true
                    },
                    port: {
                        get: function () { return instance.port; },
                        set: function (v) { instance.port = v; },
                        enumerable: true, configurable: true
                    },
                    pathname: {
                        get: function () {
                            // IE does not include leading '/' in |pathname|
                            if (instance.pathname.charAt(0) !== '/') return '/' + instance.pathname;
                            return instance.pathname;
                        },
                        set: function (v) { instance.pathname = v; },
                        enumerable: true, configurable: true
                    },
                    search: {
                        get: function () { return instance.search; },
                        set: function (v) {
                            if (instance.search === v) return;
                            instance.search = v; tidy_instance(); update_steps();
                        },
                        enumerable: true, configurable: true
                    },
                    searchParams: {
                        get: function () { return query_object; },
                        enumerable: true, configurable: true
                    },
                    hash: {
                        get: function () { return instance.hash; },
                        set: function (v) { instance.hash = v; tidy_instance(); },
                        enumerable: true, configurable: true
                    },
                    toString: {
                        value: function() { return instance.toString(); },
                        enumerable: false, configurable: true
                    },
                    valueOf: {
                        value: function() { return instance.valueOf(); },
                        enumerable: false, configurable: true
                    }
                });
    
                function tidy_instance() {
                    var href = instance.href.replace(/#$|\?$|\?(?=#)/g, '');
                    if (instance.href !== href)
                        instance.href = href;
                }
    
                function update_steps() {
                    query_object._setList(instance.search ? urlencoded_parse(instance.search.substring(1)) : []);
                    query_object._update_steps();
                }
    
                return self;
            }
    
            if (origURL) {
                for (var i in origURL) {
                    if (Object.prototype.hasOwnProperty.call(origURL, i) && typeof origURL[i] === 'function')
                        URL[i] = origURL[i];
                }
            }
    
            global.URL = URL;
            global.URLSearchParams = URLSearchParams;
        })();
    
        // Patch native URLSearchParams constructor to handle sequences/records
        // if necessary.
        (function() {
            if (new global.URLSearchParams([['a', 1]]).get('a') === '1' &&
                    new global.URLSearchParams({a: 1}).get('a') === '1')
                return;
            var orig = global.URLSearchParams;
            global.URLSearchParams = function(init) {
                if (init && typeof init === 'object' && isSequence(init)) {
                    var o = new orig();
                    Array.from(init).forEach(function (e) {
                        if (!isSequence(e)) throw TypeError();
                        var nv = Array.from(e);
                        if (nv.length !== 2) throw TypeError();
                        o.append(nv[0], nv[1]);
                    });
                    return o;
                } else if (init && typeof init === 'object') {
                    o = new orig();
                    Object.keys(init).forEach(function(key) {
                        o.set(key, init[key]);
                    });
                    return o;
                } else {
                    return new orig(init);
                }
            };
        })();
    
    }(self));
    
    // URL.prototype.toJSON
    // eslint-disable-next-line no-unused-vars
    (function (global) {
        global.URL.prototype.toJSON = function toJSON() {
            return this.href;
        }
    }(self));
    })
    ('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});
    